/* eslint-disable react-hooks/rules-of-hooks */
import {
  Col,
  Row,
  Layout,
  Checkbox,
  Space,
  Input,
  Form,
  Select,
  Divider,
  Modal,
  Pagination,
  Spin,
  Collapse,
  Tag,
  Result,
  Table,
  Upload,
} from 'antd';
import { Content } from 'antd/es/layout/layout';
import { MainLayout } from 'components';
import Button from 'components/Button';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import pageTitleStore from 'store/pageTitleStore';
import {
  BasilLayout,
  BasilLayoutBlue,
  FilterGoldIcon,
  FilterIcon,
  MingcuteLayout,
  MingcuteLayoutBlue,
  SortingOutLine,
} from 'assets/svg';
import Sider from 'antd/es/layout/Sider';
import {
  ClearOutlined,
  CloseCircleOutlined,
  CloseOutlined,
  CodeSandboxCircleFilled,
  CopyOutlined,
  DownOutlined,
  SortAscendingOutlined,
  UpOutlined,
} from '@ant-design/icons';
import CartApi from 'apis/CartApi';
import { useMutation, useQuery } from 'react-query';
import ProductCartTVV from 'components/Modules/Cart/CartTVV/ProductCartTVV';
import { openNotificationWithIcon } from 'utils/notification';
import { ListOrderTVVDetail } from 'interface/cart.interface';
import { useHistory, useLocation } from 'react-router-dom';
import { useUser } from 'contexts/User';
import ProductCartInfo from 'components/Modules/Cart/CartTVV/ProductCartInfo';
import CapitalApi from 'apis/CapitalApi';
import AllocateApi from 'apis/AllocateApi';
import formatCurrencyVND from 'utils/formatCurrencyVND';
import { useForm } from 'antd/es/form/Form';
import ProductApi from 'apis/ProductApi';
import { Radio } from 'antd/lib';
import PriceSlider from 'components/PriceSlider';
import ProductCartTableTVV from 'components/Modules/Cart/CartTVV/ProductCartTableTVV';
import DropdownComponent from 'components/DropdownComponent';
import TableCapitalProductCartList from './TableCapitalProductCartList';
import ModalCopyCart from './ModalCopyCart';
import PopupConfirmBase from 'components/PopupConfirmBase';
import PopupOrderConfirm from './PopupOrderConfirm';
import styled from '@emotion/styled';
import ModalImportCart from './ModalImportCart';
import handleError401 from 'utils/handleError401';

export default function TvvCartList() {
  const history = useHistory();
  const { Option } = Select;
  const [form] = useForm();
  const modalRef = useRef<{ setData: (data: any) => void } | null>(null);
  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);
  const [isOpenModalCopyCart, setIsOpenModalCopyCart] =
    useState<boolean>(false);
  const [isOpenModalImportCart, setIsOpenModalImportCart] =
    useState<boolean>(false);
  const location = useLocation<{
    cart: any;
    lstSelected: any;
    page: number;
    page_size: number;
  }>();
  const cart = location.state?.cart;
  const page = location.state?.page || 1;
  const page_size = location.state?.page_size || 12;
  const lstSelected = location.state?.lstSelected || [];

  const ASC = 'asc ';
  const DESC = 'desc ';

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [visible, setVisible] = useState<boolean>(false);
  const { user } = useUser();
  const isOrder =
    user?.role?.includes('cua_hang_truong') ||
    user?.role?.includes('nguoi_dat_hang')
      ? true
      : false;

  const toggleFilter = () => {
    setIsOpenFilter(!isOpenFilter);
  };

  const [isOpenFilterAdvanced, setIsOpenFilterAdvanced] =
    useState<boolean>(false);
  const toggleFilterAdvanced = () => {
    setIsOpenFilterAdvanced(!isOpenFilterAdvanced);
  };
  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);

  const [productListSelected, setProductListSelected] =
    useState<any>(lstSelected);

  const [isCalculatorFilter, setIsCalculatorFilter] = useState<any>(false);

  const [productListSelectedFilter, setProductListSelectedFilter] =
    useState<any>([]);

  const [isCopiedCart, setIsCopiedCart] = useState<boolean>(false);
  const [selectedTuCopy, setSelectedTuCopy] = useState([]);

  const sortData = [
    'Mới nhất',
    'Bán chạy',
    'Đăng ký kỳ trước',
    'Sức bán trung bình',
  ];
  const [selectedTags, setSelectedTags] = useState<string>();
  const [modalData, setModalData] = useState<any>(null);
  const [search, setSearch] = useState<any>();
  const [placeHolderSearch, setPlaceHolderSearch] =
    useState<string>('Nhập mã mẫu');
  const [checked, setChecked] = useState<any>('ma_mau');
  const [nhanhangSelected, setNhanHang] = useState<any>();
  const [plhhSelected, setPLHH] = useState<any>();
  const [tuXmanSelected, setTuXman] = useState<any>();
  const [donghangsapSelected, setDongHangSAP] = useState<any>();
  const [donghangxmanSelected, setDongHangXMAN] = useState<any>();
  const [nganhhangSelected, setNganhHang] = useState<any>();
  const [chungloaiSelected, setChungLoai] = useState<any>();
  const [isPKAging, setPKAging] = useState<any>();
  const [isBoCap, setBoCap] = useState<any>();
  const [isDacBiet, setDacBiet] = useState<any>();
  const [isHistory, setHistory] = useState<any>();
  const [isPresent, setPresent] = useState<any>();
  const [formSubmitParams, setFormSubmitParams] = useState<any>();
  const [bstSelected, setBST] = useState<any[]>();
  const [softSelected, setSoftSelected] = useState<any>();
  // const [softTypeSelected, setSoftTypeSelected] = useState<any>();
  // const [listProductCheck, setListProductCheck] = useState<any>([]);
  const [bgBtnDisabled, setBgBtnDisabled] = useState<string>('');
  const [listAging, setListAging] = useState<any>([]);

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isModalConfirmOpen, setIsModalConfirmOpen] = useState<boolean>(false);
  const [isShowDefault, setIsShowDefault] = useState<boolean>(true);
  const [isOpenPLHH, setIsOpenPLHH] = useState<boolean>(false);
  const [isOpenTuXman, setIsOpenTuXman] = useState<boolean>(false);
  const [isOpenDongHang, setIsOpenDongHang] = useState<boolean>(false);
  const [isOpenNganhHang, setIsOpenNganhHang] = useState<boolean>(false);
  const [isOpenChungLoai, setIsOpenChungLoai] = useState<boolean>(false);
  const [isOpenBoCap, setIsOpenBoCap] = useState<boolean>(false);
  const [isOpenPKAging, setIsOpenPKAging] = useState<boolean>(false);
  const [isOpenTinhTrang, setIsOpenTinhTrang] = useState<boolean>(false);
  const [isStatusModalOpen, setIsStatusModalOpen] = useState<boolean>(false);

  const [cartData, setCartData] = useState<any>();
  const [totalData, setTotalData] = useState<any>();
  const [total, setTotal] = useState<any>();
  const [dataFilter, setDataFilter] = useState<any>();
  const [checkTotal, setCheckTotal] = useState<any>(0);
  const [productSelectedQuantity, setProductSelectedQuantity] =
    useState<number>();
  const [capitalYear, setCapitalYear] = useState<number | null>(null);
  const [isCapitalYearLoaded, setIsCapitalYearLoaded] = useState(false);

  useEffect(() => {
    const branchCodeRaw = user?.branch_code ?? user?.plantCode;
    const branchCode =
      branchCodeRaw !== undefined && branchCodeRaw !== null
        ? String(branchCodeRaw)
        : undefined;

    const fallbackYear = new Date().getFullYear();

    if (!branchCode) {
      setCapitalYear(fallbackYear);
      setIsCapitalYearLoaded(true);
      return;
    }

    const fetchMaxCapitalYear = async () => {
      setIsCapitalYearLoaded(false);
      try {
        const response = await AllocateApi.getMaxCapitalYear(branchCode);
        const maxCapitalYear = response?.data?.max_capital_year;

        if (maxCapitalYear !== undefined && maxCapitalYear !== null) {
          const parsedYear = Number(maxCapitalYear);
          if (!Number.isNaN(parsedYear)) {
            setCapitalYear(parsedYear);
            setIsCapitalYearLoaded(true);
            return;
          }
        }

        setCapitalYear(fallbackYear);
        setIsCapitalYearLoaded(true);
      } catch (error: any) {
        if (error?.response?.status === 401) {
          handleError401();
        }
        setCapitalYear(fallbackYear);
        setIsCapitalYearLoaded(true);
      }
    };

    fetchMaxCapitalYear();
  }, [user?.branch_code, user?.plantCode]);

  const handleChange = (tag: string, checked: boolean) => {
    if (tag == selectedTags) {
      setSelectedTags(undefined);
    } else {
      setSelectedTags(tag);
    }
    history.push('/order-product-list/create', {
      cart: cart,
      lstSelected: productListSelected,
      page: 1,
      page_size: page_size,
    });
  };

  const showModal = (data: any) => {
    modalRef?.current?.setData(data?.product);
    if (data) {
      setModalData(data);
    }
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setModalData(undefined);
    setIsModalVisible(false);
    setVisible(false);
  };

  const handleReset = () => {
    form.resetFields();
    setFormSubmitParams(undefined);
    history.push('/order-product-list/create', {
      cart: cart,
      lstSelected: productListSelected,
      page: 1,
      page_size: page_size,
    });
  };

  const handleStatusModal = () => {
    if ((cartData || []).length === 0) {
      setIsStatusModalOpen(false);
    } else {
      if (
        (cartData || [])[0]?.cart_order_tvv_status == 1 ||
        (cartData || [])[0]?.cart_order_tvv_status == 3 ||
        (cartData || [])[0]?.cart_order_tvv_status == 4 ||
        (cartData || [])[0]?.cart_order_tvv_status == 5 ||
        (cartData || [])[0]?.cart_order_tvv_status == 7
      ) {
        setIsStatusModalOpen(true);
        setBgBtnDisabled('bg-gray-300');
      } else {
        setIsStatusModalOpen(false);
        setBgBtnDisabled('bg-primary-50');
      }
    }
  };

  useEffect(() => {
    handleStatusModal();
  }, [(cartData || [])[0]?.cart_order_tvv_status]);

  const validateUnisex = (product: any) => {
    if (
      product?.gioitinh === '3' &&
      product?.chung_loai_code === '7108' &&
      product?.nganh_hang === 'Vàng' &&
      product?.zma_ts_cap !== ''
    ) {
      if (
        (product?.order_max ?? 0) % 2 == 0 &&
        (product?.order_min ?? 0) % 2 == 0
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  const IsAgingRequire = (product: any) => {
    if (
      product?.aging_shop == 0 ||
      product?.aging_shop == null ||
      product.aging_shop == undefined
    ) {
      return false;
    } else {
      if (product.aging_shop > 3) {
        return false;
      } else {
        if (
          product?.old_order_min !== null &&
          product?.old_order_max !== null
        ) {
          return true;
        } else {
          return false;
        }
      }
    }
  };

  const isValidateAgingPass = (product: any) => {
    if (IsAgingRequire(product) === false) {
      return true;
    } else {
      if (
        product?.order_min * 1 < product?.old_order_min * 1 ||
        product?.order_max * 1 < product?.old_order_max * 1
      ) {
        return false;
      } else {
        return true;
      }
    }
  };

  const onFinish = (values: any) => {
    console.log('values: ', values);
    const filteredData = Object.fromEntries(
      Object.entries(values).filter(([_, value]) => value !== undefined)
    );
    const stringifiedData: { [key: string]: any } = {};
    Object.keys(filteredData).forEach((key) => {
      if (
        key == 'plhh' ||
        key == 'dong_hang' ||
        key == 'nganh_hang' ||
        key == 'chung_loai' ||
        key == 'loai_da' ||
        key == 'nhom_da' ||
        key == 'line_xman' ||
        key == 'line_sap' ||
        key == 'material_type' ||
        key == 'kldg_3tc' ||
        key == 'purity_of_gold' ||
        key == 'material_group' ||
        key == 'aging' ||
        key == 'bst' ||
        key == 'ohot_kc' ||
        key == 'phankhuc_gia' ||
        key == 'gioi_tinh' ||
        key == 'mausac' ||
        key == 'phan_nhom' ||
        key == 'thang_vao_dmkn' ||
        key == 'basic_status' ||
        key == 'dghh_kv' ||
        key == 'item_size'
      ) {
        stringifiedData[key] = filteredData[key];
      } else if (key == 'cost_price') {
        const values: any = filteredData[key];
        stringifiedData['min_cost_price'] = values[0];
        stringifiedData['max_cost_price'] = values[1];
      } else if (key == 'price') {
        const values: any = filteredData[key];
        stringifiedData['min_price'] = values[0];
        stringifiedData['max_price'] = values[1];
        // eslint-disable-next-line no-dupe-else-if
      } else if (key == 'purity_of_gold') {
        stringifiedData[key] = Number(filteredData[key]);
      } else {
        stringifiedData[key] = String(filteredData[key]);
      }
    });

    setFormSubmitParams(stringifiedData);
    history.push('/order-product-list/create', {
      cart: cart,
      lstSelected: productListSelected,
      page: 1,
      page_size: page_size,
    });
  };

  const cart_code = cart?.cart_code;
  // const list_id_cart_register_detail = cart?.list_cart_register_detail;
  const functionParams = {
    page: page,
    page_size: page_size,
    cart_code: cart_code,
    ...(isCapitalYearLoaded &&
      capitalYear !== null && { capital_year: capitalYear }),
    // list_id_cart_register_detail: list_id_cart_register_detail,
    ...(search && checked == 'ma_mau' && { ma_mau: search }),
    ...(search && checked == 'pro_code' && { pro_code: search }),
    ...(search && checked == 'basic_product' && { basic_product: search }),

    ...(nhanhangSelected &&
      nhanhangSelected.length != 0 && { nhan_hang: nhanhangSelected }),
    ...(plhhSelected && plhhSelected.length != 0 && { plhh: plhhSelected }),
    ...(tuXmanSelected &&
      tuXmanSelected.length != 0 && { tu_xman: tuXmanSelected }),
    ...(donghangsapSelected &&
      donghangsapSelected.length != 0 && { line_sap: donghangsapSelected }),
    ...(donghangxmanSelected &&
      donghangxmanSelected.length != 0 && { line_xman: donghangxmanSelected }),
    ...(nganhhangSelected &&
      nganhhangSelected.length != 0 && { nganh_hang: nganhhangSelected }),
    ...(chungloaiSelected &&
      chungloaiSelected.length != 0 && { chung_loai: chungloaiSelected }),
    ...(isBoCap && isBoCap == 'is_group_bo' && { is_group_bo: true }),
    ...(isBoCap && isBoCap == 'is_group_cap' && { is_group_cap: true }),
    ...(isBoCap && isBoCap == 'bo_bat_buoc' && { bo_bat_buoc: true }),
    ...(isBoCap && isBoCap == 'bo_khong_bat_buoc' && { bo_bat_buoc: false }),
    ...(isDacBiet && { nhom_dac_biet: [isDacBiet] }),
    ...(isPKAging && { phan_khuc_aging: [isPKAging] }),
    ...(isPresent &&
      isPresent == 'chua_dat' && {
        has_min_max: false,
        list_ma_mau: productListSelected.map((product: any) => product.ma_mau),
      }),
    ...(isPresent &&
      isPresent == 'da_dat' && {
        has_min_max: true,
        list_ma_mau: productListSelected.map((product: any) => product.ma_mau),
      }),
    ...(isPresent &&
      isPresent == 'dang_ky_sai' && {
        has_min_max: true,
        list_ma_mau: productListSelected
          .filter((product: any) => {
            return (
              product.order_min <= 0 ||
              product.order_max <= 0 ||
              product.order_min > product.order_max ||
              validateUnisex(product) == false ||
              product.order_min == undefined ||
              product.order_max == undefined ||
              isValidateAgingPass(product) == false
            );
          })
          .map((product: any) => product.ma_mau),
      }),
    ...(isPresent &&
      isPresent == 'aging_check' && {
        has_min_max: true,
        list_ma_mau: listAging
          .filter(
            (itemA: any) =>
              !productListSelected.some(
                (itemB: any) => itemB.ma_mau === itemA.ma_mau
              )
          )
          .map((product: any) => product.ma_mau),
      }),
    ...(isPresent &&
      isPresent == 'canh_bao' && {
        has_min_max: false,
        list_ma_mau: productListSelected
          .filter((product: any) => {
            return (
              product.order_min >= 5 ||
              product.order_max >= 5 ||
              product.order_max - product.order_min >= 4
            );
          })
          .map((product: any) => product.ma_mau),
      }),
    ...(bstSelected && { bst: bstSelected }),
    ...(formSubmitParams && formSubmitParams),
    ...(selectedTags && { sort_type: sortData.indexOf(selectedTags) + 1 }),
    ...(softSelected &&
      softSelected != undefined && {
        sort_field: softSelected['sort_field'],
        sort_field_type: softSelected['sort_field_type'],
      }),
  };

  // const params = JSON.parse(JSON.stringify(functionParams));
  const {
    // data: cartData,
    isLoading: getCartsLoading,
    mutate: postCartTVV,
  } = useMutation(
    ['getCartTVV', functionParams],
    () => CartApi.postCartTVV(functionParams),
    {
      onSuccess: (data: any) => {
        if (data.status === 'success') {
          setCartData(data.data);
          if (checkTotal == 0) {
            setTotalData(data.total);
          }
          setTotal(data.total);
          setDataFilter(data.total);
          setCheckTotal(checkTotal + 1);
        }
      },
    }
  );

  const {
    // data: cartData,
    isLoading: getAginngListLoading,
    mutate: getAginngList,
  } = useMutation(
    ['getCartTVV'],
    async () =>
      CartApi.postCartTVV({
        cart_code: cart_code,
        list_aging: [1, 2, 3],
        ...(isCapitalYearLoaded &&
          capitalYear !== null && { capital_year: capitalYear }),
      }),
    {
      onSuccess: (data: any) => {
        if (data.status === 'success') {
          setListAging(
            (data.data || []).filter((item: any) => {
              return item?.old_order_max != null && item?.old_order_min != null;
            })
          );

          const updatedProducts = [...productListSelected];
          ///////// Tìm các cặp (bộ) nào mà trong cặp đó chưa có old_order_max, old_order_min thì gán cho thằng còn lại lun
          const groupedCapProducts = data.data.reduce(
            (acc: any, product: any) => {
              if (
                product.zma_ts_cap != null &&
                product.zma_ts_cap != '' &&
                product.zma_ts_cap != undefined
              ) {
                if (!acc[product.zma_ts_cap]) {
                  acc[product.zma_ts_cap] = [];
                }
                acc[product.zma_ts_cap].push(product);
              }
              return acc;
            },
            {}
          );

          const groupedByZmaBo = data.data.reduce((acc: any, product: any) => {
            if (
              product.zma_bo != null &&
              product.zma_bo !== '' &&
              product.zma_bo !== undefined
            ) {
              if (!acc[product.zma_bo]) {
                acc[product.zma_bo] = [];
              }
              acc[product.zma_bo].push(product);
            }
            return acc;
          }, {});

          const products = data.data.map((product: any) => {
            const groupCap = groupedCapProducts[product.zma_ts_cap];
            const groupBo = groupedByZmaBo[product.zma_bo];
            if (
              groupCap &&
              (!product.old_order_max || !product.old_order_min)
            ) {
              const maxProduct = groupCap.find((p: any) => p.old_order_max);
              const minProduct = groupCap.find((p: any) => p.old_order_min);
              return {
                ...product,
                old_order_max:
                  product.old_order_max || maxProduct?.old_order_max,
                old_order_min:
                  product.old_order_min || minProduct?.old_order_min,
              };
            }
            if (groupBo && (!product.old_order_max || !product.old_order_min)) {
              const maxProduct = groupBo.find((p: any) => p.old_order_max);
              const minProduct = groupBo.find((p: any) => p.old_order_min);
              return {
                ...product,
                old_order_max:
                  product.old_order_max || maxProduct?.old_order_max,
                old_order_min:
                  product.old_order_min || minProduct?.old_order_min,
              };
            }
            return product;
          });
          ////////////////////////

          for (const newProduct of products) {
            const existingProductIndex = updatedProducts.findIndex(
              (p) => p.ma_mau === newProduct.ma_mau
            );

            if (existingProductIndex == -1) {
              if (
                newProduct.old_order_max != null &&
                newProduct.old_order_min != null &&
                newProduct.old_order_max != undefined &&
                newProduct.old_order_min != undefined &&
                newProduct.old_order_max != '' &&
                newProduct.old_order_min != ''
              ) {
                newProduct.order_min = newProduct.old_order_min;
                newProduct.order_max = newProduct.old_order_max;
                updatedProducts.push(newProduct);
              } else {
                newProduct.order_min = 1;
                newProduct.order_max = 1;
                newProduct.old_order_min = 1;
                newProduct.old_order_max = 1;
                updatedProducts.push(newProduct);
              }
            }
          }

          setProductListSelected(updatedProducts);
        }
      },
    }
  );

  const isAgingPass = () => {
    const input = productListSelected?.filter((item: any) => {
      return (
        // item?.old_order_max != null &&
        // item?.old_order_min != null &&
        // item?.old_order_max != undefined &&
        // item?.old_order_min != undefined &&
        // item?.old_order_max != '' &&
        // item?.old_order_min != '' &&
        item?.aging_shop < 4 && item?.aging_shop > 0
      );
    });

    const newAging = listAging?.filter((item: any) => {
      return (
        item?.old_order_max != null &&
        item?.old_order_min != null &&
        item?.old_order_max != undefined &&
        item?.old_order_min != undefined &&
        item?.old_order_max != '' &&
        item?.old_order_min != '' &&
        item?.aging_shop < 4 &&
        item?.aging_shop > 0
      );
    });

    const check: any[] = [];
    const uncheck: any[] = [];

    if (input?.length > 0) {
      const maMauSet = new Set(listAging?.map((obj: any) => obj?.ma_mau));
      input.forEach((item: any) => {
        if (maMauSet.has(item?.ma_mau)) {
          check.push(item);
        } else {
          uncheck.push(item);
        }
      });
    }

    console.log('uncheck:', uncheck);
    console.log('check:', check);
    console.log('aging:', newAging);

    newAging.forEach((item: any) => {
      const existsInCheck = check.some(
        (aging: any) => aging.basic_product === item.basic_product
      );

      if (!existsInCheck) {
        console.log('khac', item);
      }
    });

    if (check?.length >= newAging?.length) {
      return true;
    } else {
      handleCheckDuplicates(newAging);
      return false;
    }
  };

  const handleCheckDuplicates = (data: any) => {
    const map = new Map();
    const duplicates = new Set();

    data.forEach((item: any) => {
      const key = item.ma_mau;
      if (map.has(key)) {
        duplicates.add(key);
      } else {
        map.set(key, true);
      }
    });

    if (duplicates.size > 0) {
      console.log('Các mã mẫu trùng: ' + Array.from(duplicates).join(', '));
    }
  };

  const {
    data: xmanOfCartData,
    mutate: postCartXman,
    isLoading: tuxmanLoading,
  } = useMutation(['postCartXman'], () =>
    CartApi.postCartXman({
      cart_code: cart_code,
      ...(isCapitalYearLoaded &&
        capitalYear !== null && { capital_year: capitalYear }),
    })
  );

  const { isLoading: getFilterLoading, mutate: filterSelectedCartRegister } =
    useMutation(
      ['filterSelectedCartRegister', functionParams],
      () =>
        CartApi.filterSelectedCartRegister({
          ...functionParams,
          list_id_cart_register_detail: productListSelected.map(
            (item: any) => item?.cart_register_detail_id
          ),
        }),
      {
        onSuccess: ({ data, status }: any) => {
          if (status === 'success') {
            setProductListSelectedFilter(data[0].ids ?? []);
          }
        },
      }
    );

  const convertStatus = (status: number) => {
    switch (status) {
      case undefined:
      case null:
      case 0:
        return 'Mới tạo';
      case 1:
        return 'TVV duyệt gửi CHT';
      case 2:
        return 'CHT từ Chối';
      case 3:
        return 'CHT duyệt gửi CN';
      case 4:
        return 'CN từ Chối';
      case 5:
        return 'CN duyệt gửi HS';
      case 6:
        return 'HS từ chối';
      case 7:
        return 'HS duyệt';
      default:
        return '-';
    }
  };

  const {
    isLoading: getFullMinMaxCartOrderLoading,
    mutate: getFullMinMaxCartOrder,
  } = useMutation(
    ['getFullMinMaxCartOrder'],
    (params: any) =>
      CartApi.getFullMinMaxCartOrder(
        params.cart_code,
        params.selectedTuCopy,
        capitalYear ?? undefined
      ),
    {
      onSuccess: (res: any) => {
        if (res.data) {
          const updatedProducts = [...productListSelected];
          const updatedProductsFilter = [...productListSelectedFilter];

          for (const newProduct of res.data) {
            newProduct.old_order_min = newProduct.order_min;
            newProduct.old_order_max = newProduct.order_max;
            const existingProductIndex = updatedProducts.findIndex(
              (p) => p.ma_mau === newProduct.ma_mau
            );
            const existingProductIndexFilter = updatedProductsFilter?.findIndex(
              (p) => p === newProduct?.cart_register_detail_id
            );
            if (isCopiedCart) {
              if (existingProductIndex !== -1) {
                updatedProducts.splice(existingProductIndex, 1);
              }
              if (existingProductIndexFilter !== -1) {
                updatedProductsFilter.splice(existingProductIndexFilter, 1);
              }
            } else {
              if (existingProductIndex !== -1) {
                updatedProducts[existingProductIndex] = newProduct;
              } else {
                updatedProducts.push(newProduct);
              }

              if (existingProductIndexFilter !== -1) {
                updatedProductsFilter[existingProductIndexFilter] =
                  newProduct?.cart_register_detail_id;
              } else {
                updatedProductsFilter.push(newProduct?.cart_register_detail_id);
              }
            }
          }
          setProductListSelected(updatedProducts);
          if (isCopiedCart) {
            if (isCapitalYearLoaded) {
              getMinMaxQuantityCartOrderTVV();
            }
          }
        }
        if (isCopiedCart) {
          setSelectedTuCopy([]);
        }
        setIsCopiedCart(!isCopiedCart);
        setIsCalculatorFilter(true);
      },
      onError: (e: any) => {
        openNotificationWithIcon('error', e);
      },
    }
  );

  // useEffect(() => {
  //   console.log('select tu', selectedTuCopy);
  // }, [selectedTuCopy]);

  const {
    isLoading: getMinMaxQuantityCartOrderTVVLoading,
    mutate: getMinMaxQuantityCartOrderTVV,
  } = useMutation(
    ['getMinMaxQuantityCartOrderTVV'],
    () =>
      CartApi.getMinMaxQuantityCartOrderTVV(
        cart.cart_code,
        isCapitalYearLoaded && capitalYear !== null ? capitalYear : undefined
      ),
    {
      onSuccess: (res: any) => {
        if (res.data) {
          const updatedProducts = [...productListSelected];
          const updatedProductsFilter = [...productListSelectedFilter];

          for (const newProduct of res.data) {
            const existingProductIndex = updatedProducts.findIndex(
              (p) => p.ma_mau === newProduct.ma_mau
            );
            const existingProductIndexFilter = updatedProductsFilter.findIndex(
              (p) => p === newProduct.cart_register_detail_id
            );

            if (existingProductIndex !== -1) {
              updatedProducts[existingProductIndex] = newProduct;
            } else {
              updatedProducts.push(newProduct);
            }

            if (existingProductIndexFilter !== -1) {
              updatedProductsFilter[existingProductIndexFilter] =
                newProduct?.cart_register_detail_id;
            } else {
              updatedProductsFilter.push(newProduct?.cart_register_detail_id);
            }
          }

          setProductListSelected(updatedProducts);
        }
        setIsCalculatorFilter(true);
        if (isCapitalYearLoaded && capitalYear !== null) {
          getAginngList();
        }
      },
      onError: (e: any) => {
        openNotificationWithIcon('error', e);
      },
    }
  );

  const {
    mutate: getCapitalShop,
    data: capitalData,
    isLoading: getCapitalShopLoading,
  } = useMutation(
    ['getCapitalShop'],
    (variables: { shopId: number; year: number | null }) =>
      CapitalApi.getCapitalShop(variables.shopId, variables.year)
  );

  const getHHKN = () => {
    const data = (capitalData?.data?.product_capital_pof_info || []).filter(
      (item: any) => {
        return item?.danh_muc === cart?.cart_type;
      }
    );
    return {
      minHHKN: (data || [])[0]?.price_min || 0,
      maxHHKN: (data || [])[0]?.price_max || 0,
    };
  };

  const capital_remain = {
    min: getHHKN().minHHKN - (capitalData?.data.capital_used_min || 0),
    max: getHHKN().maxHHKN - (capitalData?.data.capital_used_max || 0),
  };

  const { mutate: getProductOption, data: lstProductOption } = useMutation(
    ['getProductOption'],
    () => ProductApi.getProductOption() // lấy ds option
  );

  const { mutate: getLsdFilter, data: lsdFilter } = useMutation(
    ['getLsdFilter'],
    () =>
      CartApi.postCartTVV({
        page: page,
        page_size: page_size,
        cart_code: cart_code,
        is_get_option_list: true,
        ...(capitalYear && { capital_year: capitalYear }),
      })
  );

  const pthh_list = lsdFilter?.data?.filter(
    (option: any) => option.type === 'plhh'
  );

  const plhh =
    pthh_list == undefined || pthh_list.length == 0 ? [] : pthh_list[0]['list'];

  const phannhom = lstProductOption?.data?.filter(
    (option: any) => option.type === 'phan_nhom'
  )[0]['list'];

  const donghangsap = lstProductOption?.data?.filter(
    (option: any) => option.type === 'line_sap'
  )[0]['list'];

  const nganhhang = lsdFilter?.data?.filter(
    (option: any) => option.type === 'nganh_hang'
  )[0]['list'];

  const chungloai = lsdFilter?.data?.filter(
    (option: any) => option.type === 'chung_loai'
  )[0]['list'];

  const pkaging_list = lsdFilter?.data?.filter(
    (option: any) => option.type === 'phan_khuc_aging'
  );
  const pkaging =
    pkaging_list == undefined || pkaging_list.length == 0
      ? []
      : pkaging_list[0]['list'];

  const nhomdacbietdata = lsdFilter?.data?.filter(
    (option: any) => option.type === 'nhom_dac_biet'
  );
  const nhomdacbiet =
    nhomdacbietdata == undefined || nhomdacbietdata?.length == 0
      ? []
      : nhomdacbietdata[0]['list'];

  const bst = lstProductOption?.data?.filter(
    (option: any) => option.type === 'bst'
  )[0]['list'];

  const phankhuc = lstProductOption?.data?.filter(
    (option: any) => option.type === 'phankhuc'
  )[0]['list'];

  const costprice = lstProductOption?.data?.filter(
    (option: any) => option.type === 'cost_price'
  )[0]['data'];

  const price = lstProductOption?.data?.filter(
    (option: any) => option.type === 'price'
  )[0]['data'];

  const loaida = lstProductOption?.data?.filter(
    (option: any) => option.type === 'loai_da'
  )[0]['list'];

  const nhomda = lstProductOption?.data?.filter(
    (option: any) => option.type === 'nhom_da'
  )[0]['list'];

  const donghangxman = lstProductOption?.data?.filter(
    (option: any) => option.type === 'line_xman'
  )[0]['list'];

  const gioitinh = lstProductOption?.data?.filter(
    (option: any) => option.type === 'gioitinh'
  )[0]['list'];

  const bo = lsdFilter?.data?.filter(
    (option: any) => option.type === 'zma_bo'
  )[0]['list'];

  const cap = lsdFilter?.data?.filter(
    (option: any) => option.type === 'zma_ts_cap'
  )[0]['list'];

  const xman = lstProductOption?.data?.filter(
    (option: any) => option.type === 'xman'
  )[0]['list'];

  const tuxman = lsdFilter?.data?.filter(
    (option: any) => option.type === 'tu_xman'
  )[0]['list'];

  const kldg_3tc = lstProductOption?.data?.filter(
    (option: any) => option.type === 'kldg_3tc'
  )[0]['list'];

  const materialtype_list = lstProductOption?.data?.filter(
    (option: any) => option.type === 'material_type'
  );

  const materialtype =
    materialtype_list == undefined || materialtype_list.length == 0
      ? []
      : materialtype_list[0]['list'];

  const material_group = lstProductOption?.data?.filter(
    (option: any) => option.type === 'material_group'
  )[0]['list'];

  const purity_of_gold = lstProductOption?.data?.filter(
    (option: any) => option.type === 'purity_of_gold'
  )[0]['list'];

  const aging = lstProductOption?.data?.filter(
    (option: any) => option.type === 'aging'
  )[0]['list'];

  const thang_vao_dmkn_list = lstProductOption?.data?.filter(
    (option: any) => option.type === 'thang_vao_dmkn'
  );
  const thang_vao_dmkn =
    thang_vao_dmkn_list == undefined || thang_vao_dmkn_list.length == 0
      ? []
      : thang_vao_dmkn_list[0]['list'];

  const dghh_kv_list = lstProductOption?.data?.filter(
    (option: any) => option.type === 'dghh_kv'
  );
  const dghh_kv =
    dghh_kv_list == undefined || dghh_kv_list.length == 0
      ? []
      : dghh_kv_list[0]['list'];

  const basic_status_list = lstProductOption?.data?.filter(
    (option: any) => option.type === 'basic_status'
  );
  const basic_status =
    basic_status_list == undefined || basic_status_list.length == 0
      ? []
      : basic_status_list[0]['list'];

  const mausac = lstProductOption?.data?.filter(
    (option: any) => option.type === 'mausac'
  )[0]['list'];

  const phankhuc_gia = lstProductOption?.data?.filter(
    (option: any) => option.type === 'phankhuc_gia'
  )[0]['list'];

  const ohot_kc = lstProductOption?.data?.filter(
    (option: any) => option.type === 'ohot_kc'
  )[0]['list'];

  const vonDKTamTinhMin = useMemo(() => {
    return productListSelected?.reduce((acc: any, product: any) => {
      if (
        productListSelectedFilter?.includes(product?.cart_register_detail_id)
      ) {
        return acc + (product.order_min ?? 0) * (product.cost_price ?? 0);
      } else {
        return acc;
      }
    }, 0);
  }, [productListSelectedFilter, productListSelected]);
  const vonDKTamTinhMax = useMemo(() => {
    return productListSelected?.reduce((acc: any, product: any) => {
      if (
        productListSelectedFilter?.includes(product?.cart_register_detail_id)
      ) {
        return acc + (product.order_max ?? 0) * (product.cost_price ?? 0);
      } else {
        return acc;
      }
    }, 0);
  }, [productListSelectedFilter, productListSelected]);

  const handleCheckProduct = (index: number, product: any, event: any) => {
    // console.log('product: ', product);
    if (event.target.checked) {
      // for (let i = 0; i < productListSelected.length; i++) {
      //   if (
      //     productListSelected[i].order_min == undefined ||
      //     productListSelected[i].order_min == null
      //   ) {
      //     openNotificationWithIcon(
      //       'error',
      //       'Số lượng thấp nhất không được để trống'
      //     );
      //     return;
      //   } else if (
      //     productListSelected[i].order_max == undefined ||
      //     productListSelected[i].order_max == null
      //   ) {
      //     openNotificationWithIcon(
      //       'error',
      //       'Số lượng cao nhất không được để trống'
      //     );
      //     return;
      //   } else if (
      //     productListSelected[i].order_min > productListSelected[i].order_max
      //   ) {
      //     openNotificationWithIcon(
      //       'error',
      //       'Số lượng thấp nhất không được lớn hơn số lượng cao nhất'
      //     );
      //     return;
      //   } else if (productListSelected[i].order_min <= 0) {
      //     openNotificationWithIcon(
      //       'error',
      //       'Số lượng thấp nhất không được bằng 0'
      //     );
      //     return;
      //   }
      // }
      setProductListSelectedFilter([
        ...productListSelectedFilter,
        product.cart_register_detail_id,
      ]);
      setProductListSelected([...productListSelected, product]);
    } else {
      setProductListSelectedFilter(
        productListSelectedFilter?.filter(
          (selectedProductFilter: any) =>
            selectedProductFilter != product.cart_register_detail_id
        )
      );
      setProductListSelected(
        productListSelected.filter(
          (selectedProduct: any) => selectedProduct.ma_mau != product.ma_mau
        )
      );
    }
  };

  const handleMinMaxProduct = (index: number, product: any) => {
    let updatedProductSelecteds = [...productListSelected];
    if (product.order_min >= 0 && product.order_max >= 0) {
      const productsFilter = productListSelectedFilter?.filter(
        (selectedProduct: any) =>
          selectedProduct != product.cart_register_detail_id
      );
      const products = productListSelected.filter(
        (selectedProduct: any) => selectedProduct.ma_mau != product.ma_mau
      );
      setProductListSelectedFilter([
        ...productsFilter,
        product.cart_register_detail_id,
      ]);
      updatedProductSelecteds = [...products, product];
      setProductListSelected(updatedProductSelecteds);
    }
    // for (let i = 0; i < productListSelected.length; i++) {
    //   if (
    //     productListSelected[i].order_min == undefined ||
    //     productListSelected[i].order_min == null
    //   ) {
    //     openNotificationWithIcon(
    //       'error',
    //       'Số lượng thấp nhất không được để trống'
    //     );
    //     break;
    //   } else if (
    //     productListSelected[i].order_max == undefined ||
    //     productListSelected[i].order_max == null
    //   ) {
    //     openNotificationWithIcon(
    //       'error',
    //       'Số lượng cao nhất không được để trống'
    //     );
    //     break;
    //   } else if (
    //     productListSelected[i].order_min > productListSelected[i].order_max
    //   ) {
    //     // openNotificationWithIcon(
    //     //   'error',
    //     //   'Số lượng thấp nhất không được lớn hơn số lượng cao nhất'
    //     // );
    //     break;
    //   } else if (productListSelected[i].order_min <= 0) {
    //     // openNotificationWithIcon(
    //     //   'error',
    //     //   'Số lượng thấp nhất không được nhỏ hơn hoặc bằng 0'
    //     // );
    //     break;
    //   }
    // }
  };

  const { mutate: createOrderByTvv, isLoading: loadingCreate } = useMutation(
    CartApi.createCartTVV,
    {
      onSuccess: (data: any, variable: any) => {
        if (data?.status === 'failure') {
          if (data?.message === 'cart for cart_register already exist') {
            openNotificationWithIcon(
              'error',
              'Đơn hàng đã gửi Cửa hàng trưởng duyệt',
              'Bạn không thể thêm sản phẩm'
            );
          } else {
            openNotificationWithIcon('error', 'Tạo đơn hàng thất bại');
          }
        } else {
          if (variable.action == 'push') {
            pushNewPage();
            openNotificationWithIcon('success', 'Tạo đơn hàng thành công');
            history.push(`/order/tvv-view/${cart?.cart_register_id}`);
          } else {
            if (isCopiedCart) {
              handleCopyCart();
            }
            openNotificationWithIcon('success', 'Lưu đơn hàng thành công');
            // pushNewPage();
            history.push('/order-product-list/create', {
              cart: cart,
              lstSelected: productListSelected,
              page: page,
              page_size: page_size,
            });
          }
        }
      },
      onError: () => {
        openNotificationWithIcon('error', 'Tạo đơn hàng thất bại');
      },
    }
  );

  const { mutate: importCartRegister, isLoading: loadingImport } = useMutation(
    CartApi.importCartRegister,
    {
      onSuccess: (data: any) => {
        const updatedList = [...productListSelected];

        data.data.forEach((newProduct: any) => {
          const existingIndex = updatedList.findIndex(
            (product) => product.ma_mau === newProduct.ma_mau
          );

          if (existingIndex !== -1) {
            updatedList[existingIndex] = {
              ...updatedList[existingIndex],
              ...newProduct,
            };
          } else {
            updatedList.push(newProduct);
          }
        });
        setProductListSelected(updatedList);
      },
      onError: () => {
        openNotificationWithIcon('error', 'Import thất bại');
      },
    }
  );

  const isValidateUnisexPass = (product: any) => {
    if (
      product?.gioitinh === '3' &&
      product?.chung_loai_code === '7108' &&
      product?.nganh_hang === 'Vàng' &&
      product?.zma_ts_cap !== ''
    ) {
      if (product?.order_max % 2 == 0 && product?.order_min % 2 == 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  const handleCreateOrderTVV = async () => {
    const product = [] as unknown as ListOrderTVVDetail[];

    for (let i = 0; i < productListSelected.length; i++) {
      if (
        productListSelected[i].order_min == undefined ||
        productListSelected[i].order_min == null
      ) {
        openNotificationWithIcon(
          'error',
          'Số lượng thấp nhất không được để trống'
        );
        break;
      } else if (
        productListSelected[i].order_max == undefined ||
        productListSelected[i].order_max == null
      ) {
        openNotificationWithIcon(
          'error',
          'Số lượng cao nhất không được để trống'
        );
        break;
      } else if (
        productListSelected[i].order_min > productListSelected[i].order_max
      ) {
        openNotificationWithIcon(
          'error',
          'Số lượng min không được lớn hơn số lượng max'
        );
        break;
      } else if (productListSelected[i].order_min <= 0) {
        openNotificationWithIcon(
          'error',
          'Số lượng min không được nhỏ hơn hoặc bằng 0'
        );
        break;
      } else if (isValidateUnisexPass(productListSelected[i]) === false) {
        openNotificationWithIcon(
          'error',
          'Đơn hàng có mẫu thuộc nhẫn Unisex chưa đăng ký số lượng MIN-MAX chẵn'
        );
        break;
      } else if (isValidateAgingPass(productListSelected[i]) === false) {
        openNotificationWithIcon(
          'error',
          'không thể đặt hàng',
          'Aging nhỏ hơn hoặc bằng 3: min max không được nhỏ hơn mix max cũ'
        );
        break;
      } else if (isAgingPass() === false) {
        openNotificationWithIcon(
          'error',
          'Không thể đặt hàng',
          'Các sản phẩm có aging bắt buộc chưa được đặt đủ'
        );
        break;
      } else {
        const paramProduct = {
          cart_register_detail_id:
            productListSelected[i].cart_register_detail_id,
          order_min: productListSelected[i].order_min,
          order_max: productListSelected[i].order_max,
          list_order_size: [
            {
              size: null,
              value: 0,
            },
          ],
        } as unknown as ListOrderTVVDetail;
        product.push(paramProduct);
      }
    }
    if (product.length > 0 && product.length == productListSelected.length) {
      const data = {
        shop_id: user?.plantId || 0,
        cart_register_id: cart?.cart_register_id,
        list_order_tvv_detail: product,
      };
      setIsModalConfirmOpen(true);
    }
    if (productListSelected.length == 0) {
      openNotificationWithIcon(
        'error',
        'Giỏ hàng không có sản phẩm',
        'Chọn sản phẩm để đặt hàng'
      );
    }
  };

  const createOrder = (action: string) => {
    setIsModalConfirmOpen(false);

    const product = [] as unknown as ListOrderTVVDetail[];
    for (let i = 0; i < productListSelected.length; i++) {
      const paramProduct = {
        ma_mau: productListSelected[i].ma_mau,
        cart_register_detail_id: productListSelected[i].cart_register_detail_id,
        order_min: productListSelected[i].order_min,
        order_max: productListSelected[i].order_max,
        list_order_size: [
          {
            size: null,
            value: 0,
          },
        ],
      } as unknown as ListOrderTVVDetail;
      product.push(paramProduct);
    }

    const data = {
      shop_id: user?.plantId || 0,
      cart_register_id: cart?.cart_register_id,
      list_order_tvv_detail: product,
      action: action,
    };
    createOrderByTvv(data);
  };

  const handleCopyCart = () => {
    if (!isCapitalYearLoaded || capitalYear === null) {
      return;
    }
    if (!xmanOfCartData) {
      postCartXman();
    }
    if (isCopiedCart) {
      getFullMinMaxCartOrder({
        cart_code: cart.cart_code,
        selectedTuCopy: selectedTuCopy,
      });
    } else {
      setIsOpenModalCopyCart((prev) => !prev);
    }
  };

  useEffect(() => {
    if (!isCapitalYearLoaded) {
      return;
    }
    if (!lsdFilter && cartData) {
      getMinMaxQuantityCartOrderTVV();

      getLsdFilter();
    }
    if (
      !lstProductOption &&
      lsdFilter &&
      capitalYear !== null &&
      user?.plantId
    ) {
      getCapitalShop({
        shopId: user.plantId,
        year: capitalYear,
      });
      getProductOption();
    }
  }, [cartData, lsdFilter, capitalYear, user?.plantId, isCapitalYearLoaded]);
  useEffect(() => {
    if (!isCapitalYearLoaded) {
      return;
    }
    setTitle('Giỏ hàng');
    setBreadcrumb([
      {
        title: (
          <p>
            <a href="/product-register">Giỏ hàng</a>{' '}
          </p>
        ),
      },
      {
        title: (
          <p>
            <a href="/product-register">Đăng ký SP kinh doanh</a>
          </p>
        ),
      },
      {
        title: <a href="">{cart?.cart_name} </a>,
      },
    ]);
    const pageTitle = 'PNJ - PMS';
    document.title = pageTitle;
    postCartTVV();
    productListSelected?.length > 0 &&
      productListSelected.length > 0 &&
      filterSelectedCartRegister();
  }, [
    user,
    page,
    page_size,
    search,
    formSubmitParams,
    nhanhangSelected,
    plhhSelected,
    tuXmanSelected,
    donghangsapSelected,
    nganhhangSelected,
    chungloaiSelected,
    isBoCap,
    isDacBiet,
    isPresent,
    bstSelected,
    selectedTags,
    softSelected,
    checked,
    isPKAging,
    isCapitalYearLoaded,
    capitalYear,
    // productListSelectedFilter,
  ]);

  useEffect(() => {
    if (!isCapitalYearLoaded || capitalYear === null) {
      return;
    }
    if (isCalculatorFilter && productListSelected.length > 0) {
      filterSelectedCartRegister();
      setIsCalculatorFilter(false);
    }
  }, [
    isCalculatorFilter,
    productListSelected,
    isCapitalYearLoaded,
    capitalYear,
  ]);

  const handleEnter = (event: any) => {
    setSearch(event.target.value);
    pushNewPage();
  };

  function handleClearFilter(event: any) {
    setPLHH(undefined);
    setTuXman(undefined);
    setDongHangSAP(undefined);
    setChungLoai(undefined);
    setNganhHang(undefined);
    setBoCap(undefined);
    setPresent(undefined);
    setPKAging(undefined);
    setDacBiet(undefined);
  }

  const handleSort = (value: any) => {
    if (value == undefined || value == null) {
      setSoftSelected(undefined);
    } else {
      const Str = value.split(' ');
      setSoftSelected({
        sort_field: Str[1],
        sort_field_type: Str[0],
      });
    }
  };

  const handleSortColumn = (event: any) => {
    setSoftSelected({
      sort_field: event.target.id,
      sort_field_type:
        softSelected == undefined || softSelected?.sort_field_type == 'desc'
          ? 'asc'
          : 'desc',
    });
  };

  // const handleSortColumn(event) {
  //   const id = event.target.id;
  //   console.log(id);
  // }

  function pushNewPage() {
    history.push('/order-product-list/create', {
      cart: cart,
      lstSelected: productListSelected,
      page: 1,
      page_size: page_size,
    });
  }

  const getZmaTsCap = (maCAp: string) => {
    const newProductListSelected = productListSelected.filter((item: any) => {
      return item.zma_ts_cap !== maCAp;
    });
    setProductListSelected(newProductListSelected);
  };

  const removeProductInPack = (maBo: string) => {
    const newProductListSelected = productListSelected.filter((item: any) => {
      return item.zma_bo !== maBo;
    });
    setProductListSelected(newProductListSelected);
  };

  const groupedProducts: any = {};

  if (
    isBoCap == 'is_group_bo' ||
    isBoCap == 'is_group_cap' ||
    isBoCap == 'bo_bat_buoc'
  ) {
    cartData?.forEach((product: any) => {
      const category =
        isBoCap == 'is_group_bo' || isBoCap == 'bo_bat_buoc'
          ? product.zma_bo_text
          : product.zma_ts_cap_text;
      if (!groupedProducts[category]) {
        groupedProducts[category] = {
          group_text: category,
          products: [],
        };
      }
      groupedProducts[category].products.push(product);
    });
  }

  const groups = Object.values(groupedProducts);

  const checkIsPackEnough = (maBo: string, packQuantity: number) => {
    setProductSelectedQuantity((productListSelected || []).length || 0);
    const check = (productListSelected || []).filter((product: any) => {
      return product.zma_bo === maBo;
    });

    if ((check || []).length === packQuantity) {
      return true;
    } else {
      return false;
    }
  };

  const checkIsPackEnoughCallBack = useCallback(checkIsPackEnough, [
    productListSelected,
  ]);

  const checkIsIdExist = (cart_register_detail_id: number) => {
    const productFilter = (productListSelected || []).filter((product: any) => {
      return product.cart_register_detail_id === cart_register_detail_id;
    });

    if ((productFilter || []).length > 0) {
      return { IsIdExist: true, product: productFilter[0] };
    } else {
      return { IsIdExist: false, product: undefined };
    }
  };

  function handleSelectTuXman(data: any) {
    setTuXman([data.code]);
    pushNewPage();
  }

  function handleSelectChungLoai(data: any) {
    setChungLoai([data.chung_loai_code]);
    pushNewPage();
  }

  return (
    <MainLayout>
      <Spin
        spinning={
          getCartsLoading ||
          loadingCreate ||
          getFullMinMaxCartOrderLoading ||
          tuxmanLoading ||
          getMinMaxQuantityCartOrderTVVLoading ||
          getAginngListLoading ||
          loadingImport
        }
      >
        <Layout style={{ backgroundColor: '#F1F9FF' }}>
          <Sider
            style={{
              backgroundColor: 'white',
              width: '178px',
              padding: '14px',
              marginRight: '20px',
              borderRadius: '8px',
            }}
          >
            <span
              style={{
                color: '#00538F',
                fontSize: '16px',
                fontWeight: 'bold',
              }}
            >
              Lọc nhanh
            </span>
            <span
              style={{
                float: 'right',
                color:
                  plhhSelected?.length ||
                  tuXmanSelected?.length ||
                  donghangsapSelected?.length ||
                  nhanhangSelected?.length ||
                  chungloaiSelected?.length ||
                  nganhhangSelected?.length ||
                  isBoCap?.length ||
                  isPresent?.length ||
                  isPKAging?.length ||
                  isDacBiet?.length
                    ? '#DE0129'
                    : '#1C1C1C',
              }}
              className="cursor-pointer"
              onClick={handleClearFilter}
            >
              Hủy
            </span>
            {/* <Divider
              style={{
                borderTop: '1px dashed rgba(0, 0, 0, 0.2)',
                marginTop: '8px',
                marginBottom: '0px',
              }}
              dashed
            />
            <Collapse
              style={{
                  fontWeight: 'bold',
                  fontSize: '12px',
                  background: 'white',
                }}
              expandIcon={({ isActive }) => (
                <DownOutlined rotate={isActive ? 180 : 0} />
              )}
              expandIconPosition="right"
              bordered={false}
              items={[
                {
                  key: '1',
                  label: 'Theo nhãn hàng',

                  children: (
                    <Checkbox.Group
                      onChange={(value) => {
                        setNhanHang(value);
                      }}
                    >
                      {nhanhang &&
                        nhanhang.map((item: any) => (
                          <Checkbox
                            key={item.prod_grp3}
                            value={item.prod_grp3}
                            style={{
                              fontWeight: 'normal',
                              fontSize: '12px',
                              marginBottom: '6px',
                              width: '100%',
                            }}
                          >
                            {item.prod_grp3 + ' - ' + item.prod_grp3_name}
                          </Checkbox>
                        ))}
                    </Checkbox.Group>
                  ),
                },
              ]}
            /> */}
            <div className="my-5">
              <p className="text-md font-bold mt-3">Thông tin sản phẩm</p>
              <Divider
                style={{
                  borderTop: '1px dashed rgba(0, 0, 0, 0.2)',
                  marginTop: '8px',
                  marginBottom: '0px',
                }}
                dashed
              />
              <Collapse
                className="custom-collapse-header"
                style={{
                  fontWeight: 'bold',
                  fontSize: '12px',
                  background: 'white',
                }}
                expandIcon={({ isActive }) => (
                  <DownOutlined rotate={isActive ? 180 : 0} />
                )}
                bordered={false}
                onChange={(key) => setIsOpenPLHH(!!key.length)}
                items={[
                  {
                    key: '1',
                    label: (
                      <Row
                        style={{
                          justifyContent: 'space-between',
                        }}
                      >
                        <p
                          style={{
                            fontWeight: 'bold',
                            fontSize: '12px',
                            width: '120px',
                          }}
                          className={`${
                            plhhSelected?.length && !isOpenPLHH
                              ? 'text-primary-50'
                              : ''
                          }`}
                        >
                          Phân loại hàng hóa
                        </p>
                        {/* {plhhSelected?.length > 0 && (
                          <span
                            onClick={(event) => {
                              event.stopPropagation();
                              setPLHH(undefined);
                              pushNewPage();
                            }}
                            style={{
                              color: 'red',
                              fontSize: '11px',
                            }}
                          >
                            Hủy
                          </span>
                        )} */}
                      </Row>
                    ),

                    children: (
                      <Checkbox.Group
                        value={plhhSelected}
                        onChange={(value) => {
                          setPLHH(value);
                          pushNewPage();
                        }}
                        style={{
                          fontWeight: 'normal',
                          fontSize: '12px',
                          marginBottom: '6px',
                          width: '100%',
                          display: 'block',
                          alignItems: 'flex-start',
                        }}
                      >
                        {plhh &&
                          plhh.map((item: any) => (
                            <Checkbox
                              key={item.code}
                              value={item.code}
                              style={{
                                fontWeight: 'normal',
                                fontSize: '12px',
                                marginBottom: '6px',
                                width: '100%',
                              }}
                            >
                              {item.name}
                            </Checkbox>
                          ))}
                      </Checkbox.Group>
                    ),
                  },
                ]}
              />
              <Divider
                style={{
                  borderTop: '1px dashed rgba(0, 0, 0, 0.2)',
                  marginTop: '8px',
                  marginBottom: '0px',
                }}
                dashed
              />
              <Collapse
                className="custom-collapse-header"
                style={{
                  fontWeight: 'bold',
                  fontSize: '12px',
                  background: 'white',
                }}
                expandIcon={({ isActive }) => (
                  <DownOutlined rotate={isActive ? 180 : 0} />
                )}
                bordered={false}
                onChange={(key) => setIsOpenTuXman(!!key.length)}
                items={[
                  {
                    key: '1',
                    label: (
                      <Row
                        style={{
                          justifyContent: 'space-between',
                        }}
                      >
                        <p
                          style={{
                            fontWeight: 'bold',
                            fontSize: '12px',
                          }}
                          className={`${
                            tuXmanSelected?.length && !isOpenTuXman
                              ? 'text-primary-50'
                              : ''
                          }`}
                        >
                          Tủ Xman
                        </p>
                        {/* {tuXmanSelected?.length > 0 && (
                          <span
                            onClick={(event) => {
                              event.stopPropagation();
                              setTuXman(undefined);
                              pushNewPage();
                            }}
                            style={{
                              color: 'red',
                              fontSize: '11px',
                            }}
                          >
                            Hủy
                          </span>
                        )} */}
                      </Row>
                    ),

                    children: (
                      <Checkbox.Group
                        value={tuXmanSelected}
                        onChange={(value) => {
                          setTuXman(value);
                          pushNewPage();
                        }}
                        style={{
                          fontWeight: 'normal',
                          fontSize: '12px',
                          marginBottom: '6px',
                          width: '100%',
                          display: 'block',
                          alignItems: 'flex-start',
                        }}
                      >
                        {tuxman &&
                          tuxman.map((item: any) => (
                            <Checkbox
                              key={item.code}
                              value={item.code}
                              style={{
                                fontWeight: 'normal',
                                fontSize: '12px',
                                marginBottom: '6px',
                                width: '100%',
                              }}
                            >
                              {item.name}
                            </Checkbox>
                          ))}
                      </Checkbox.Group>
                    ),
                  },
                ]}
              />
              <Divider
                style={{
                  borderTop: '1px dashed rgba(0, 0, 0, 0.2)',
                  marginTop: '8px',
                  marginBottom: '0px',
                }}
                dashed
              />
              <Collapse
                className="custom-collapse-header"
                style={{
                  fontWeight: 'bold',
                  fontSize: '12px',
                  background: 'white',
                }}
                expandIcon={({ isActive }) => (
                  <DownOutlined rotate={isActive ? 180 : 0} />
                )}
                bordered={false}
                onChange={(key) => {
                  setIsOpenNganhHang(!!key.length);
                }}
                items={[
                  {
                    key: '1',
                    label: (
                      <Row
                        style={{
                          justifyContent: 'space-between',
                        }}
                      >
                        <p
                          style={{
                            fontWeight: 'bold',
                            fontSize: '12px',
                          }}
                          className={`${
                            nganhhangSelected?.length && !isOpenNganhHang
                              ? 'text-primary-50'
                              : ''
                          }`}
                        >
                          Ngành hàng
                        </p>
                        {/* {nganhhangSelected?.length > 0 && (
                          <span
                            onClick={(event) => {
                              event.stopPropagation();
                              setNganhHang(undefined);
                              pushNewPage();
                            }}
                            style={{
                              color: 'red',
                              fontSize: '11px',
                            }}
                          >
                            Hủy
                          </span>
                        )} */}
                      </Row>
                    ),

                    children: (
                      <Checkbox.Group
                        value={nganhhangSelected}
                        onChange={(value) => {
                          setNganhHang(value);
                          pushNewPage();
                        }}
                      >
                        {nganhhang &&
                          nganhhang.map((item: any) => (
                            <Checkbox
                              key={item.code}
                              value={item.code}
                              style={{
                                fontWeight: 'normal',
                                fontSize: '12px',
                                marginBottom: '6px',
                                width: '100%',
                              }}
                            >
                              {item.name}
                            </Checkbox>
                          ))}
                      </Checkbox.Group>
                    ),
                  },
                ]}
              />
              <Divider
                style={{
                  borderTop: '1px dashed rgba(0, 0, 0, 0.2)',
                  marginTop: '8px',
                  marginBottom: '0px',
                }}
                dashed
              />
              <Collapse
                className="custom-collapse-header"
                style={{
                  fontWeight: 'bold',
                  fontSize: '12px',
                  background: 'white',
                }}
                expandIcon={({ isActive }) => (
                  <DownOutlined rotate={isActive ? 180 : 0} />
                )}
                bordered={false}
                onChange={(key) => setIsOpenDongHang(!!key.length)}
                items={[
                  {
                    key: '1',
                    label: (
                      <Row
                        style={{
                          justifyContent: 'space-between',
                        }}
                      >
                        <p
                          style={{
                            fontWeight: 'bold',
                            fontSize: '12px',
                          }}
                          className={`${
                            donghangsapSelected?.length && !isOpenDongHang
                              ? 'text-primary-50'
                              : ''
                          }`}
                        >
                          Dòng hàng
                        </p>
                        {/* {donghangsapSelected?.length > 0 && (
                          <span
                            onClick={(event) => {
                              event.stopPropagation();
                              setDongHangSAP(undefined);
                              pushNewPage();
                            }}
                            style={{
                              color: 'red',
                              fontSize: '11px',
                            }}
                          >
                            Hủy
                          </span>
                        )} */}
                      </Row>
                    ),

                    children: (
                      <Checkbox.Group
                        value={donghangsapSelected}
                        onChange={(value) => {
                          setDongHangSAP(value);
                          pushNewPage();
                        }}
                        style={{
                          fontWeight: 'normal',
                          fontSize: '12px',
                          marginBottom: '6px',
                          width: '100%',
                          display: 'block',
                          alignItems: 'flex-start',
                        }}
                      >
                        {donghangsap &&
                          donghangsap.map((item: any) => (
                            <Checkbox
                              key={item.line_sap}
                              value={item.line_sap}
                              style={{
                                fontWeight: 'normal',
                                fontSize: '12px',
                                marginBottom: '6px',
                                width: '100%',
                              }}
                            >
                              {item.line_sap_text}
                            </Checkbox>
                          ))}
                      </Checkbox.Group>
                    ),
                  },
                ]}
              />

              <Divider
                style={{
                  borderTop: '1px dashed rgba(0, 0, 0, 0.2)',
                  marginTop: '8px',
                  marginBottom: '0px',
                }}
                dashed
              />
              <Collapse
                className="custom-collapse-header"
                style={{
                  fontWeight: 'bold',
                  fontSize: '12px',
                  background: 'white',
                }}
                expandIcon={({ isActive }) => (
                  <DownOutlined rotate={isActive ? 180 : 0} />
                )}
                bordered={false}
                onChange={(key) => setIsOpenChungLoai(!!key.length)}
                items={[
                  {
                    key: '1',
                    label: (
                      <Row
                        style={{
                          justifyContent: 'space-between',
                        }}
                      >
                        <p
                          style={{
                            fontWeight: 'bold',
                            fontSize: '12px',
                          }}
                          className={`${
                            chungloaiSelected?.length && !isOpenChungLoai
                              ? 'text-primary-50'
                              : ''
                          }`}
                        >
                          Chủng loại
                        </p>
                        {/* {chungloaiSelected?.length > 0 && (
                          <span
                            onClick={(event) => {
                              event.stopPropagation();
                              setChungLoai(undefined);
                              pushNewPage();
                            }}
                            style={{
                              color: 'red',
                              fontSize: '11px',
                            }}
                          >
                            Hủy
                          </span>
                        )} */}
                      </Row>
                    ),

                    children: (
                      <Checkbox.Group
                        value={chungloaiSelected}
                        onChange={(value) => {
                          setChungLoai(value);
                          pushNewPage();
                        }}
                      >
                        {chungloai &&
                          chungloai.map((item: any) => (
                            <Checkbox
                              key={item.code}
                              value={item.code}
                              style={{
                                fontWeight: 'normal',
                                fontSize: '12px',
                                marginBottom: '6px',
                                width: '100%',
                              }}
                            >
                              {item.code + ' - ' + item.name}
                            </Checkbox>
                          ))}
                      </Checkbox.Group>
                    ),
                  },
                ]}
              />
              <Divider
                style={{
                  borderTop: '1px dashed rgba(0, 0, 0, 0.2)',
                  marginTop: '8px',
                  marginBottom: '0px',
                }}
                dashed
              />
              <Collapse
                className="custom-collapse-header"
                style={{
                  fontWeight: 'bold',
                  fontSize: '12px',
                  background: 'white',
                }}
                expandIcon={({ isActive }) => (
                  <DownOutlined rotate={isActive ? 180 : 0} />
                )}
                bordered={false}
                items={[
                  {
                    key: '1',
                    label: 'Nhóm đặc biệt',

                    children: nhomdacbiet.map((item: any) => (
                      <Radio
                        key={item.code}
                        checked={item.code == isDacBiet}
                        style={{
                          fontWeight: 'normal',
                          fontSize: '12px',
                          marginBottom: '6px',
                          width: '100%',
                        }}
                        onClick={() => {
                          if (item.code == isDacBiet) {
                            setDacBiet(undefined);
                          } else {
                            setDacBiet(item.code);
                          }
                          pushNewPage();
                        }}
                      >
                        {item.name}
                      </Radio>
                    )),
                  },
                ]}
              />
              <Divider
                style={{
                  borderTop: '1px dashed rgba(0, 0, 0, 0.2)',
                  marginTop: '8px',
                  marginBottom: '0px',
                }}
                dashed
              />
              <Collapse
                className="custom-collapse-header"
                style={{
                  fontWeight: 'bold',
                  fontSize: '12px',
                  background: 'white',
                }}
                expandIcon={({ isActive }) => (
                  <DownOutlined rotate={isActive ? 180 : 0} />
                )}
                bordered={false}
                onChange={(key) => {
                  setIsOpenBoCap(!!key.length);
                  console.log(
                    'chọn',
                    isBoCap,
                    'check',
                    !isBoCap ? 'true' : 'false'
                  );
                }}
                items={[
                  {
                    key: '1',
                    label: (
                      <p
                        className={`${
                          isBoCap && !isOpenBoCap ? 'text-primary-50' : ''
                        }`}
                      >
                        Bộ cặp
                      </p>
                    ),

                    children: [
                      { type: 'is_group_cap', type_text: 'Cặp' },
                      { type: 'is_group_bo', type_text: 'Bộ' },
                      { type: 'bo_bat_buoc', type_text: 'Bộ bắt buộc' },
                      // {
                      //   type: 'bo_khong_bat_buoc',
                      //   type_text: 'Bộ không bắt buộc',
                      // },
                    ].map((item: any) => (
                      <Radio
                        key={item.type}
                        checked={item.type == isBoCap}
                        style={{
                          fontWeight: 'normal',
                          fontSize: '12px',
                          marginBottom: '6px',
                          width: '100%',
                        }}
                        onClick={() => {
                          if (item.type == isBoCap) {
                            setBoCap(undefined);
                          } else {
                            setBoCap(item.type);
                          }
                          pushNewPage();
                        }}
                      >
                        {item.type_text}
                      </Radio>
                    )),
                  },
                ]}
              />
              <Divider
                style={{
                  borderTop: '1px dashed rgba(0, 0, 0, 0.2)',
                  marginTop: '8px',
                  marginBottom: '0px',
                }}
                dashed
              />
              <Collapse
                className="custom-collapse-header"
                style={{
                  fontWeight: 'bold',
                  fontSize: '12px',
                  background: 'white',
                }}
                expandIcon={({ isActive }) => (
                  <DownOutlined rotate={isActive ? 180 : 0} />
                )}
                bordered={false}
                onChange={(key) => {
                  setIsOpenPKAging(!!key.length);
                }}
                items={[
                  {
                    key: '1',
                    label: (
                      <p
                        className={`${
                          isPKAging && !isOpenPKAging ? 'text-primary-50' : ''
                        }`}
                      >
                        Phân khúc Aging CH
                      </p>
                    ),

                    children: pkaging.map((item: any) => (
                      <Radio
                        key={item.code}
                        checked={item.code == isPKAging}
                        style={{
                          fontWeight: 'normal',
                          fontSize: '12px',
                          marginBottom: '6px',
                          width: '100%',
                        }}
                        onClick={() => {
                          if (item.code == isPKAging) {
                            setPKAging(undefined);
                          } else {
                            setPKAging(item.code);
                          }
                          pushNewPage();
                        }}
                      >
                        {item.name}
                      </Radio>
                    )),
                  },
                ]}
              />
            </div>
            <p className="text-md font-bold">Tình trạng đăng ký</p>

            <Divider
              style={{
                borderTop: '1px dashed rgba(0, 0, 0, 0.2)',
                marginTop: '8px',
                marginBottom: '0px',
              }}
              dashed
            />
            <Collapse
              className="custom-collapse-header"
              style={{
                fontWeight: 'bold',
                fontSize: '12px',
                background: 'white',
              }}
              expandIcon={({ isActive }) => (
                <DownOutlined rotate={isActive ? 180 : 0} />
              )}
              bordered={false}
              onChange={(key) => setIsOpenTinhTrang(!!key.length)}
              items={[
                {
                  key: '1',
                  label: (
                    <p
                      className={`${
                        isPresent && !isOpenTinhTrang ? 'text-primary-50' : ''
                      }`}
                    >
                      Đăng ký kỳ này
                    </p>
                  ),

                  children: [
                    { type: 'toan_bo', type_text: 'Toàn bộ' },
                    { type: 'chua_dat', type_text: 'Chưa chọn' },
                    // { type: 'danh_sach_den', type_text: 'Danh sách đen' },
                    { type: 'da_dat', type_text: 'Đã chọn' },
                    {
                      type: 'dang_ky_sai',
                      type_text: 'Đăng ký sai',
                    },
                    {
                      type: 'aging_check',
                      type_text: 'Aging chưa đăng ký',
                    },
                    {
                      type: 'canh_bao',
                      type_text: 'Cảnh báo',
                    },
                  ].map((item: any) => (
                    <Radio
                      key={item.type}
                      checked={item.type == isPresent}
                      style={{
                        fontWeight: 'normal',
                        fontSize: '12px',
                        marginBottom: '6px',
                        width: '100%',
                      }}
                      onClick={() => {
                        if (item.type == isPresent) {
                          setPresent(undefined);
                        } else {
                          setPresent(item.type);
                        }
                        pushNewPage();
                      }}
                    >
                      {item.type_text}
                    </Radio>
                  )),
                },
              ]}
            />
            <Divider
              style={{
                borderTop: '1px dashed rgba(0, 0, 0, 0.2)',
                marginTop: '8px',
                marginBottom: '0px',
              }}
              dashed
            />
            <Collapse
              className="custom-collapse-header"
              style={{
                fontWeight: 'bold',
                fontSize: '12px',
                background: 'white',
              }}
              expandIcon={({ isActive }) => (
                <DownOutlined rotate={isActive ? 180 : 0} />
              )}
              bordered={false}
              items={[
                {
                  key: '1',
                  label: 'Lịch sử đăng ký',

                  children: [
                    { type: 'toan_bo', type_text: 'Toàn bộ' },
                    { type: 'is_group_bo', type_text: 'Có đặt ở kỳ trước' },
                    { type: 'is_group_cap', type_text: 'Danh sách đen' },
                    {
                      type: 'is_group_cap',
                      type_text: 'Chưa đăng ký kỳ trước',
                    },
                  ].map((item: any) => (
                    <Radio
                      key={item.type}
                      checked={item.type == isHistory}
                      style={{
                        fontWeight: 'normal',
                        fontSize: '12px',
                        marginBottom: '6px',
                        width: '100%',
                      }}
                      onClick={() => {
                        if (item.type == isHistory) {
                          setHistory(undefined);
                        } else {
                          setHistory(item.type);
                        }
                        pushNewPage();
                      }}
                    >
                      {item.type_text}
                    </Radio>
                  )),
                },
              ]}
            />

            <Divider
              style={{
                borderTop: '1px dashed rgba(0, 0, 0, 0.2)',
                marginTop: '8px',
                marginBottom: '0px',
              }}
              dashed
            />
          </Sider>
          <Layout style={{ backgroundColor: '#F1F9FF' }}>
            <Row
              gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
              style={{ backgroundColor: '#F1F9FF' }}
            >
              <Col className="flex items-center" span={10}>
                <Select
                  size="small"
                  defaultValue="Mã mẫu"
                  options={[
                    { value: 'ma_mau', label: 'Mã mẫu' },
                    { value: 'basic_product', label: 'Mã khuôn' },
                    { value: 'pro_code', label: 'Mã sản phẩm' },
                  ]}
                  onChange={(value) => {
                    if (value == 'ma_mau') {
                      setPlaceHolderSearch('Nhập mã mẫu');
                    } else if (value == 'basic_product') {
                      setPlaceHolderSearch('Nhập mã khuôn');
                    } else if (value == 'pro_code') {
                      setPlaceHolderSearch('Nhập mã sản phẩm');
                    }
                    setChecked(value);
                  }}
                />
                <Input
                  size="small"
                  className="h-[41px] ml-2 w-full"
                  placeholder={placeHolderSearch}
                  onPressEnter={(event: any) => {
                    handleEnter(event);
                  }}
                  onKeyDown={(event: any) => {
                    if (event.key == 'Enter') {
                      handleEnter(event);
                    }
                  }}
                />
              </Col>
              <ModalCopyCart
                setSelectedTuCopy={setSelectedTuCopy}
                open={isOpenModalCopyCart}
                setOpen={setIsOpenModalCopyCart}
                dataCheckbox={
                  xmanOfCartData?.data?.filter(
                    (option: any) => option.type === 'tu_xman'
                  )[0]['list']
                }
                getFullMinMaxCartOrder={() => {
                  if (!isCapitalYearLoaded || capitalYear === null) {
                    return;
                  }
                  getFullMinMaxCartOrder({
                    cart_code: cart.cart_code,
                    selectedTuCopy,
                  });
                }}
                selectedTuCopy={selectedTuCopy}
              />
              <ModalImportCart
                open={isOpenModalImportCart}
                setOpen={setIsOpenModalImportCart}
                listProducts={(products: any) => {
                  importCartRegister({
                    cart_register_id: cart?.cart_register_id,
                    data_import: products,
                  });
                }}
              />
              <Col span={14} className="flex justify-end">
                <Space>
                  {/* <Button
                    bgColor={'bg-white'}
                    color={'text-primary-50'}
                    border={'border-primary-50'}
                    customClass="fix-border-radius"
                    onClick={() => {
                      setIsOpenModalImportCart(true);
                    }}
                  >
                    Import
                  </Button> */}

                  {isOrder && (
                    <Button
                      bgColor={'bg-white'}
                      color={'text-primary-50'}
                      border={'border-primary-50'}
                      onClick={handleCopyCart}
                      customClass="hover:text-[#33AAFF] hover:border-[#33AAFF]"
                    >
                      <CopyOutlined />
                      {isCopiedCart
                        ? 'Hủy sao chép giỏ hàng cũ'
                        : 'Sao chép giỏ hàng cũ'}
                    </Button>
                  )}

                  <Button
                    bgColor={'bg-white'}
                    color={`${
                      isOpenFilter ? 'text-primary-50' : 'text-secondary-50'
                    }`}
                    border={`${
                      isOpenFilter ? 'border-primary-50' : 'border-secondary-50'
                    }`}
                    onClick={toggleFilter}
                  >
                    {isOpenFilter ? <FilterIcon /> : <FilterGoldIcon />}
                    Lọc
                  </Button>

                  {isOrder && cartData?.length != 0 && (
                    <Button
                      bgColor={
                        Date.now() > new Date(cart.expiration_date).getTime()
                          ? 'bg-gray-300'
                          : bgBtnDisabled
                      }
                      onClick={() => {
                        if (
                          Date.now() > new Date(cart.expiration_date).getTime()
                        ) {
                          setIsModalOpen(true);
                        } else if (
                          cartData[0].cart_order_tvv_status == undefined ||
                          cartData[0].cart_order_tvv_status == null ||
                          cartData[0].cart_order_tvv_status == 0 ||
                          cartData[0].cart_order_tvv_status == 2
                        ) {
                          handleCreateOrderTVV();
                        } else {
                          openNotificationWithIcon(
                            'error',
                            'Giỏ hàng đã được ' +
                              convertStatus(
                                cartData == undefined || cartData?.length == 0
                                  ? null
                                  : cartData[0].cart_order_tvv_status
                              )
                          );
                        }
                      }}
                    >
                      Đăng ký
                    </Button>
                  )}
                </Space>
              </Col>
            </Row>

            <Form
              form={form}
              layout="vertical"
              className={`items-center ${isOpenFilter ? '' : 'hidden'} mt-4`}
              onFinish={onFinish}
              autoComplete="off"
            >
              <Content>
                <Row
                  className="h-[85px]"
                  gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                >
                  <Col className="" span={6}>
                    <Form.Item name="phan_nhom" label="Phân nhóm">
                      <Select
                        size="small"
                        placeholder="Chọn phân nhóm"
                        mode="multiple"
                        maxTagCount="responsive"
                        allowClear
                        optionFilterProp="children"
                      >
                        {phannhom &&
                          phannhom.map((item: any) => (
                            <Option
                              key={item.phan_nhom_code}
                              value={item.phan_nhom_code}
                            >
                              {item.phan_nhom}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col className="" span={6}>
                    <Form.Item name="aging" label="Aging mẫu">
                      <Select
                        optionFilterProp="children"
                        size="small"
                        placeholder="Chọn Aging mẫu"
                        mode="multiple"
                        maxTagCount="responsive"
                        allowClear
                      >
                        {aging &&
                          aging.map((item: any) => (
                            <Option key={item.aging} value={item.aging}>
                              {item.aging}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col className="" span={6}>
                    <Form.Item name="thang_vao_dmkn" label="Tháng vào DMKN">
                      <Select
                        size="small"
                        placeholder="Chọn tháng vào DMKN"
                        mode="multiple"
                        maxTagCount="responsive"
                        allowClear
                        optionFilterProp="children"
                      >
                        {thang_vao_dmkn &&
                          thang_vao_dmkn.map((item: any) => (
                            <Option
                              key={item.thang_vao_dmkn}
                              value={item.thang_vao_dmkn}
                            >
                              {item.thang_vao_dmkn}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col className="" span={6}>
                    <Form.Item name="basic_status" label="Basic status">
                      <Select
                        size="small"
                        placeholder="Chọn basic status"
                        mode="multiple"
                        maxTagCount="responsive"
                        allowClear
                        optionFilterProp="children"
                      >
                        {basic_status &&
                          basic_status.map((item: any) => (
                            <Option
                              key={item.basic_status}
                              value={item.basic_status}
                            >
                              {item.basic_status}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  {/* <Col className="" span={6}>
                    <Form.Item name="phankhuc_gia" label="Chọn phân khúc giá">
                      <Select
                        optionFilterProp="children"
                        size="small"
                        placeholder="Chọn phân khúc giá"
                        mode="multiple"
                        maxTagCount="responsive"
                        allowClear
                      >
                        {phankhuc_gia &&
                          phankhuc_gia.map((item: any) => (
                            <Option
                              key={item.phankhuc_gia}
                              value={item.phankhuc_gia}
                            >
                              {item.phankhuc_gia}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col> */}
                </Row>

                <Row
                  className=" h-[85px]"
                  gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                >
                  {/* <Col className="" span={6}>
                    <Form.Item name="chung_loai" label="Chủng loại SAP">
                      <Select
                        optionFilterProp="children"
                        size="small"
                        placeholder="Chọn chủng loại"
                        mode="multiple"
                        maxTagCount="responsive"
                        allowClear
                      >
                        {chungloai &&
                          chungloai.map((item: any) => (
                            <Option key={item.code} value={item.code}>
                              {item.code + ' - ' + item.name}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col> */}

                  <Col className="" span={6}>
                    <Form.Item name="kldg_3tc" label="Đánh giá TQ">
                      <Select
                        optionFilterProp="children"
                        size="small"
                        placeholder="Chọn đánh giá TQ"
                        mode="multiple"
                        maxTagCount="responsive"
                        allowClear
                      >
                        {kldg_3tc &&
                          kldg_3tc.map((item: any) => (
                            <Option key={item.kldg_3tc} value={item.kldg_3tc}>
                              {item.kldg_3tc}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col className="" span={6}>
                    <Form.Item name="cost_price" label="Giá vốn bình quân">
                      {costprice && (
                        <PriceSlider
                          form={form}
                          name="cost_price"
                          price={costprice}
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col className="" span={6}>
                    <Form.Item name="price" label="Giá bán">
                      {price && (
                        <PriceSlider form={form} name="price" price={price} />
                      )}
                    </Form.Item>
                  </Col>

                  <Col className="" span={6}>
                    <Form.Item name="dghh_kv" label="Đánh giá hàng hóa khu vực">
                      <Select
                        size="small"
                        placeholder="Chọn đánh giá"
                        mode="multiple"
                        maxTagCount="responsive"
                        allowClear
                        optionFilterProp="children"
                      >
                        {dghh_kv &&
                          dghh_kv.map((item: any) => (
                            <Option
                              key={item.dghh_kv_key}
                              value={item.dghh_kv_key}
                            >
                              {item.dghh_kv}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>

                <Row justify="end">
                  <Col>
                    <Button
                      customClass="flex items-center mt-3"
                      bgColor={'bg-white'}
                      color={'text-primary-50'}
                      border={'border-white'}
                      onClick={toggleFilterAdvanced}
                    >
                      <p> Tìm kiếm nâng cao</p>
                      {isOpenFilterAdvanced ? <UpOutlined /> : <DownOutlined />}
                    </Button>
                  </Col>
                </Row>

                <Row
                  gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                  className={`items-center ${
                    isOpenFilterAdvanced ? '' : 'hidden'
                  } h-[85px]`}
                >
                  <Col className="" span={6}>
                    <Form.Item name="material_type" label="Material Type">
                      <Select
                        optionFilterProp="children"
                        size="small"
                        placeholder="Chọn Material Type"
                        mode="multiple"
                        maxTagCount="responsive"
                        allowClear
                      >
                        {materialtype &&
                          materialtype.map((item: any) => (
                            <Option
                              key={item.material_type}
                              value={item.material_type}
                            >
                              {item.material_type}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col className="" span={6}>
                    <Form.Item name="material_group" label="Material Group">
                      <Select
                        optionFilterProp="children"
                        size="small"
                        placeholder="Chọn Material Group"
                        mode="multiple"
                        maxTagCount="responsive"
                        allowClear
                      >
                        {material_group &&
                          material_group.map((item: any) => (
                            <Option
                              key={item.material_group}
                              value={item.material_group}
                            >
                              {item.material_group}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col className="" span={6}>
                    <Form.Item name="purity_of_gold" label="Tuổi vàng">
                      <Select
                        optionFilterProp="children"
                        size="small"
                        placeholder="Chọn Tuổi vàng"
                        mode="multiple"
                        allowClear
                      >
                        {purity_of_gold &&
                          purity_of_gold.map((item: any) => (
                            <Option
                              key={item.purity_of_gold}
                              value={item.purity_of_gold}
                            >
                              {Number(item.purity_of_gold)}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col className="" span={6}>
                    <Form.Item name="loai_da" label="Loại đá">
                      <Select
                        optionFilterProp="children"
                        size="small"
                        placeholder="Chọn loại đá"
                        mode="multiple"
                        maxTagCount="responsive"
                        allowClear
                      >
                        {loaida &&
                          loaida.map((item: any) => (
                            <Option
                              key={item.loai_da_code}
                              value={item.loai_da_code}
                            >
                              {item.loai_da}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  {/* <Col className="" span={6}>
                    <Form.Item name="email" label="BST">
                      <Select
                       optionFilterProp="children" placeholder={'Chọn BST'} size="small" />
                    </Form.Item>
                  </Col> */}
                </Row>

                <Row
                  gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                  className={`items-center ${
                    isOpenFilterAdvanced ? '' : 'hidden'
                  } h-[85px]`}
                >
                  <Col className="" span={6}>
                    <Form.Item name="nhom_da" label="Nhóm đá">
                      <Select
                        optionFilterProp="children"
                        size="small"
                        placeholder="Chọn nhóm đá"
                        mode="multiple"
                        maxTagCount="responsive"
                        allowClear
                      >
                        {nhomda &&
                          nhomda.map((item: any) => (
                            <Option
                              key={item.nhom_da_code}
                              value={item.nhom_da_code}
                            >
                              {item.nhom_da}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col className="" span={6}>
                    <Form.Item name="bst" label="Bộ sưu tập">
                      <Select
                        optionFilterProp="children"
                        size="small"
                        placeholder="Chọn BST"
                        allowClear
                        mode="multiple"
                        maxTagCount="responsive"
                      >
                        {bst &&
                          bst.map((item: any) => (
                            <Option value={item.bst} key={item.bst}>
                              {item.bst_text}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col className="" span={6}>
                    <Form.Item name="zma_bo" label="Bộ">
                      <Select
                        showSearch
                        optionFilterProp="children"
                        size="small"
                        placeholder="Chọn bộ"
                        allowClear
                      >
                        {bo &&
                          bo.map((item: any) => (
                            <Option key={item.code} value={item.code}>
                              {item.name}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col className="" span={6}>
                    <Form.Item name="zma_ts_cap" label="Cặp">
                      <Select
                        showSearch
                        optionFilterProp="children"
                        size="small"
                        placeholder="Chọn cặp"
                        allowClear
                      >
                        {cap &&
                          cap.map((item: any) => (
                            <Option key={item.code} value={item.code}>
                              {item.name}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>

                <Row
                  gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                  className={`items-center ${
                    isOpenFilterAdvanced ? '' : 'hidden'
                  } h-[85px]`}
                >
                  <Col className="" span={6}>
                    <Form.Item name="gioi_tinh" label="Giới tính">
                      <Select
                        optionFilterProp="children"
                        size="small"
                        placeholder="Chọn giới tính"
                        mode="multiple"
                        maxTagCount="responsive"
                        allowClear
                      >
                        {gioitinh &&
                          gioitinh.map((item: any) => (
                            <Option key={item.gioitinh} value={item.gioitinh}>
                              {item.gioitinh_text}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col className="" span={6}>
                    <Form.Item name="mausac" label="Màu sắc">
                      <Select
                        size="small"
                        placeholder="Chọn màu"
                        mode="multiple"
                        maxTagCount="responsive"
                        allowClear
                        optionFilterProp="children"
                      >
                        {mausac &&
                          mausac.map((item: any) => (
                            <Option key={item.mausac} value={item.mausac}>
                              {item.mausac_text}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col className="" span={6}>
                    <Form.Item name="ohot_kc" label="Size ổ hột">
                      <Select
                        optionFilterProp="children"
                        size="small"
                        placeholder="Chọn size ổ hột"
                        allowClear
                        mode="multiple"
                        maxTagCount="responsive"
                      >
                        {ohot_kc &&
                          ohot_kc.map((item: any) => (
                            <Option key={item.ohot_kc} value={item.ohot_kc}>
                              {item.ohot_kc_text}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col className="" span={6}>
                    <Form.Item name="xman" label="Rating">
                      <Select
                        optionFilterProp="children"
                        size="small"
                        placeholder="5 sao"
                        allowClear
                        disabled
                      >
                        {xman &&
                          xman.map((item: any) => (
                            <Option key={item.xman} value={item.xman}>
                              {item.xman}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>

                <Row
                  gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                  className={`flex justify-start items-center ${
                    isOpenFilterAdvanced ? '' : 'hidden'
                  } h-[85px]`}
                >
                  <Col className="" span={6}>
                    <Form.Item name="line_sap" label="Dòng hàng SAP">
                      <Select
                        optionFilterProp="children"
                        size="small"
                        placeholder="Nhập dòng hàng SAP"
                        allowClear
                        mode="multiple"
                        maxTagCount="responsive"
                      >
                        {donghangsap &&
                          donghangsap.map((item: any) => (
                            <Option key={item.line_sap} value={item.line_sap}>
                              {item.line_sap_text}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col className="" span={6}>
                    <Form.Item name="line_xman" label="Dòng hàng Xman">
                      <Select
                        optionFilterProp="children"
                        size="small"
                        placeholder="Chọn dòng hàng xman"
                        allowClear
                        mode="multiple"
                      >
                        {donghangxman &&
                          donghangxman.map((item: any) => (
                            <Option key={item.line_xman} value={item.line_xman}>
                              {item.line_xman_text}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                    {/* <Form.Item name="line_xman" label="Dòng hàng Xman">
                      <Select
                        size="small"
                        placeholder="Tất cả"
                        allowClear
                        mode="multiple"
                      >
                        {donghang &&
                          donghang.map((item: any) => (
                            <Option
                              key={item.line_xman_text}
                              value={item.line_xman_text}
                            >
                              {item.line_xman_text}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item> */}
                  </Col>
                </Row>

                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
                  <Col className="flex justify-end" span={8}>
                    <Space>
                      <Button
                        bgColor={'bg-white'}
                        color={'text-primary-50'}
                        border={'border-primary-50'}
                        onClick={handleReset}
                      >
                        Hủy
                      </Button>
                      <Button type="submit">Tìm kiếm</Button>
                    </Space>
                  </Col>
                </Row>
              </Content>
            </Form>
            <div className="mt-5">
              <DropdownComponent
                title="Tủ xman theo dòng hàng"
                active={false}
                onchange={() => {
                  if (!xmanOfCartData) {
                    if (!isCapitalYearLoaded || capitalYear === null) {
                      return;
                    }
                    postCartXman();
                  }
                }}
              >
                <TableCapitalProductCartList
                  tuxman={
                    xmanOfCartData?.data?.filter(
                      (option: any) => option.type === 'tu_xman'
                    )[0]['list']
                  }
                  productSelected={productListSelected}
                  handleSelectTuXman={handleSelectTuXman}
                  handleSelectChungLoai={handleSelectChungLoai}
                />
              </DropdownComponent>
            </div>

            <Col
              style={{
                backgroundColor: '#ffffff',
                marginTop: '20px',
                paddingLeft: '20px',
                paddingRight: '20px',
                paddingTop: '10px',
                paddingBottom: '10px',
              }}
            >
              <Row>
                <Col span={20}>
                  <Row>
                    <Col style={{ paddingRight: '4px' }}>Tổng mẫu:</Col>
                    <Col style={{ color: '#00538F' }}>{totalData}</Col>
                    <Col style={{ paddingLeft: '4px' }}>
                      - Đã chọn: {productListSelected?.length}
                    </Col>
                    <Col style={{ paddingLeft: '4px' }}>
                      - Chưa chọn:{' '}
                      {Number(totalData) - productListSelected?.length}
                    </Col>
                  </Row>
                </Col>
                <Col span={4} className="flex justify-end">
                  Kết quả lọc:&nbsp;<strong>{dataFilter}</strong>&nbsp;mẫu
                </Col>
              </Row>
              <Row justify={'space-between'} style={{ paddingTop: '8px' }}>
                <Row>
                  <Col style={{ paddingRight: '4px' }}>Đăng ký MIN:</Col>
                  <Col style={{ fontWeight: 'bold' }}>
                    {formatCurrencyVND(capital_remain.min || 0)}
                  </Col>
                  <Col style={{ paddingRight: '4px', paddingLeft: '8px' }}>
                    MAX:
                  </Col>
                  <Col style={{ fontWeight: 'bold' }}>
                    {formatCurrencyVND(capital_remain.max || 0)}
                  </Col>
                </Row>
                <Row>
                  <Col style={{ paddingRight: '4px' }}>Vốn ĐK tạm tính:</Col>
                  <Col style={{ color: '#C9A46D', fontWeight: 'bold' }}>
                    {formatCurrencyVND(vonDKTamTinhMin)}
                    {' - '}
                    {formatCurrencyVND(vonDKTamTinhMax)}
                  </Col>
                </Row>
              </Row>
            </Col>

            <Content
              style={{
                backgroundColor: '#EFF3F8',
                marginTop: '20px',
                paddingTop: '20px',
                paddingLeft: '0px',
              }}
            >
              {/* <Row justify={'end'} style={{ paddingTop: '20px' }}>
                <Col>
                  <Tag color="blue">
                    <strong
                      style={{
                        fontSize: '16px',
                        paddingLeft: '10px',
                        paddingRight: '10px',
                      }}
                    >
                      {convertStatus(cart?.status)}
                    </strong>
                  </Tag>
                </Col>
              </Row> */}

              <Row
                justify={'start'}
                style={{
                  paddingBottom: '10px',
                  paddingLeft: '18px',
                  paddingRight: '0px',
                  alignItems: 'center',
                }}
              >
                {/* <Row gutter={25} align={'middle'}>
                  <Col className="font-bold">Sắp xếp theo</Col>
                  <Space size={[0, 5]} wrap>
                    {sortData.map((tag) => (
                      <CheckableTag
                        key={tag}
                        checked={selectedTags?.includes(tag) ?? false}
                        onChange={(checked) => handleChange(tag, checked)}
                        style={{
                          borderRadius: '10px',
                          paddingLeft: '16px',
                          paddingRight: '16px',
                          backgroundColor: selectedTags?.includes(tag)
                            ? '#00538F'
                            : '#FFFFFF',
                          color: selectedTags?.includes(tag)
                            ? '#FFFFFF'
                            : '#757779',
                        }}
                      >
                        {tag}
                      </CheckableTag>
                    ))}
                  </Space>
                </Row> */}
                <Row
                  justify={'space-between'}
                  align={'middle'}
                  style={{ width: '100%' }}
                >
                  <Col>
                    <Select
                      size="small"
                      placeholder="Sắp xếp nâng cao"
                      allowClear
                      showSearch
                      style={{ width: '290px' }}
                      // value={bstSelected}
                      onSelect={(value) => {
                        console.log('valueSelect: ', value);
                        handleSort(value);
                        pushNewPage();
                      }}
                      onClear={() => handleSort(undefined)}
                      optionFilterProp="children"
                      options={[
                        {
                          value: 'aging_cua_hang',
                          label: (
                            <span className="text-black font-bold">
                              Aging cửa hàng
                            </span>
                          ),
                          options: [
                            {
                              label: 'Từ bé đến lớn',
                              value: ASC + 'aging_cua_hang',
                            },
                            {
                              label: 'Từ lớn đến bé',
                              value: DESC + 'aging_cua_hang',
                            },
                          ],
                        },
                        {
                          value: 'so_thang_khong_phat_sinh_doanh_thu_lien_tiep',
                          label: (
                            <span className="text-black font-bold">
                              Số tháng không phát sinh doanh thu liên tiếp
                            </span>
                          ),
                          options: [
                            {
                              label: 'Từ bé đến lớn',
                              value:
                                ASC +
                                'so_thang_khong_phat_sinh_doanh_thu_lien_tiep',
                            },
                            {
                              label: 'Từ lớn đến bé',
                              value:
                                DESC +
                                'so_thang_khong_phat_sinh_doanh_thu_lien_tiep',
                            },
                          ],
                        },
                        {
                          value: 'ton_kho_hien_tai_mon',
                          label: (
                            <span className="text-black font-bold">
                              Tồn kho hiện tại món
                            </span>
                          ),
                          options: [
                            {
                              label: 'Từ bé đến lớn',
                              value: ASC + 'ton_kho_hien_tai_mon',
                            },
                            {
                              label: 'Từ lớn đến bé',
                              value: DESC + 'ton_kho_hien_tai_mon',
                            },
                          ],
                        },
                        {
                          value: 'doanh_thu_6_thang_vnd',
                          label: (
                            <span className="text-black font-bold">
                              Doanh thu 6 tháng (VNĐ)
                            </span>
                          ),
                          options: [
                            {
                              label: 'Từ bé đến lớn',
                              value: ASC + 'doanh_thu_6_thang_vnd',
                            },
                            {
                              label: 'Từ lớn đến bé',
                              value: DESC + 'doanh_thu_6_thang_vnd',
                            },
                          ],
                        },
                        {
                          value: 'doanh_so_6_thang_mon',
                          label: (
                            <span className="text-black font-bold">
                              Doanh số 6 tháng (Món)
                            </span>
                          ),
                          options: [
                            {
                              label: 'Từ bé đến lớn',
                              value: ASC + 'doanh_so_6_thang_mon',
                            },
                            {
                              label: 'Từ lớn đến bé',
                              value: DESC + 'doanh_so_6_thang_mon',
                            },
                          ],
                        },
                        {
                          value: 'doanh_thu_tb_6_thang_vnd',
                          label: (
                            <span className="text-black font-bold">
                              Doanh thu TB 6 tháng (VNĐ)
                            </span>
                          ),
                          options: [
                            {
                              label: 'Từ bé đến lớn',
                              value: ASC + 'doanh_thu_tb_6_thang_vnd',
                            },
                            {
                              label: 'Từ lớn đến bé',
                              value: DESC + 'doanh_thu_tb_6_thang_vnd',
                            },
                          ],
                        },
                        {
                          value: 'doanh_so_tb_6_thang_mon',
                          label: (
                            <span className="text-black font-bold">
                              Doanh số TB 6 tháng (Món)
                            </span>
                          ),
                          options: [
                            {
                              label: 'Từ bé đến lớn',
                              value: ASC + 'doanh_so_tb_6_thang_mon',
                            },
                            {
                              label: 'Từ lớn đến bé',
                              value: DESC + 'doanh_so_tb_6_thang_mon',
                            },
                          ],
                        },
                        {
                          value: 'doanh_thu_ky_vong_kv_vnd',
                          label: (
                            <span className="text-black font-bold">
                              Doanh thu kỳ vọng KV (VNĐ)
                            </span>
                          ),
                          options: [
                            {
                              label: 'Từ bé đến lớn',
                              value: ASC + 'doanh_thu_ky_vong_kv_vnd',
                            },
                            {
                              label: 'Từ lớn đến bé',
                              value: DESC + 'doanh_thu_ky_vong_kv_vnd',
                            },
                          ],
                        },
                        {
                          value: 'doanh_so_ky_vong_kv_mon',
                          label: (
                            <span className="text-black font-bold">
                              Doanh số kỳ vọng KV (Món)
                            </span>
                          ),
                          options: [
                            {
                              label: 'Từ bé đến lớn',
                              value: ASC + 'doanh_so_ky_vong_kv_mon',
                            },
                            {
                              label: 'Từ lớn đến bé',
                              value: DESC + 'doanh_so_ky_vong_kv_mon',
                            },
                          ],
                        },
                        {
                          value: 'doanh_thu_ky_vong_tq_vnd',
                          label: (
                            <span className="text-black font-bold">
                              Doanh thu kỳ vọng TQ (VNĐ)
                            </span>
                          ),
                          options: [
                            {
                              label: 'Từ bé đến lớn',
                              value: ASC + 'doanh_thu_ky_vong_tq_vnd',
                            },
                            {
                              label: 'Từ lớn đến bé',
                              value: DESC + 'doanh_thu_ky_vong_tq_vnd',
                            },
                          ],
                        },
                        {
                          value: 'doanh_so_ky_vong_tq_mon',
                          label: (
                            <span className="text-black font-bold">
                              Doanh số kỳ vọng TQ (Món)
                            </span>
                          ),
                          options: [
                            {
                              label: 'Từ bé đến lớn',
                              value: ASC + 'doanh_so_ky_vong_tq_mon',
                            },
                            {
                              label: 'Từ lớn đến bé',
                              value: DESC + 'doanh_so_ky_vong_tq_mon',
                            },
                          ],
                        },

                        // {
                        //   label: 'Giá vốn bình quân',
                        //   options: [
                        //     { label: 'Từ bé đến lớn', value: ASC + 'cost_price' },
                        //     {
                        //       label: 'Từ lớn đến bé',
                        //       value: DESC + 'cost_price',
                        //     },
                        //   ],
                        // },
                        // {
                        //   label: 'Giá bán bình quân',
                        //   options: [
                        //     { label: 'Từ bé đến lớn', value: ASC + 'price' },
                        //     {
                        //       label: 'Từ lớn đến bé',
                        //       value: DESC + 'price',
                        //     },
                        //   ],
                        // },
                      ]}
                    />
                  </Col>

                  <Row align={'middle'}>
                    <Tag color="blue">
                      <strong
                        style={{
                          fontSize: '16px',
                          paddingLeft: '10px',
                          paddingRight: '10px',
                        }}
                      >
                        {convertStatus(
                          cartData == undefined || cartData?.length == 0
                            ? null
                            : cartData[0].cart_order_tvv_status
                        )}
                      </strong>
                    </Tag>

                    {isShowDefault ? (
                      <>
                        <BasilLayoutBlue width={'26px'} height={'26px'} />
                        <MingcuteLayout
                          className="cursor-pointer"
                          width={'26px'}
                          height={'26px'}
                          onClick={() => setIsShowDefault(!isShowDefault)}
                        />
                      </>
                    ) : (
                      <>
                        <BasilLayout
                          className="cursor-pointer"
                          width={'26px'}
                          height={'26px'}
                          onClick={() => setIsShowDefault(!isShowDefault)}
                        />
                        <MingcuteLayoutBlue width={'26px'} height={'26px'} />
                      </>
                    )}
                  </Row>

                  {/* </Select> */}

                  {/* <Form.Item
                    name="sort"
                    style={{
                      marginBottom: '0px',
                      marginLeft: '8px',
                    }}
                  >
                    <Select
                      defaultValue={'Sắp xếp'}
                      size="small"
                      suffixIcon={<SortAscendingOutlined />}
                      style={{ width: '120px' }}
                    />
                  </Form.Item> */}
                </Row>
              </Row>
              {isShowDefault ? (
                groups && groups.length != 0 ? (
                  groups.map((group: any) => {
                    return (
                      <Col key={group.group_text}>
                        <Col
                          className="font-bold"
                          style={{ marginBottom: '10px', marginLeft: '18px' }}
                        >
                          {group.group_text}
                        </Col>
                        <Row>
                          {group.products.map((item: any, index: number) => {
                            const checked = productListSelected.some(
                              (product: any) => product.ma_mau === item.ma_mau
                            );
                            const selectedItem = productListSelected.find(
                              (selectedProduct: any) =>
                                selectedProduct.ma_mau === item.ma_mau
                            );
                            if (selectedItem) {
                              item.order_min = selectedItem.order_min;
                              item.order_max = selectedItem.order_max;
                            }
                            return (
                              <ProductCartTVV
                                changeDetected={functionParams}
                                removeProductInPack={removeProductInPack}
                                checkCartRegisterDetailId={checkIsIdExist}
                                packQuantity={productSelectedQuantity || 0}
                                checkPack={checkIsPackEnoughCallBack}
                                handleGetPair={getZmaTsCap}
                                key={index + item.ma_mau}
                                item={item}
                                checked={checked}
                                index={index}
                                handleCheckProduct={handleCheckProduct}
                                handleMinMaxProduct={handleMinMaxProduct}
                                showModal={showModal}
                              />
                            );
                          })}
                        </Row>
                      </Col>
                    );
                  })
                ) : (
                  <Row>
                    {cartData?.map((item: any, index: number) => {
                      const checked = productListSelected.some(
                        (product: any) => product.ma_mau === item.ma_mau
                      );
                      const selectedItem = productListSelected.find(
                        (selectedProduct: any) =>
                          selectedProduct.ma_mau === item.ma_mau
                      );
                      if (selectedItem) {
                        item.order_min = selectedItem.order_min;
                        item.order_max = selectedItem.order_max;
                      } else {
                        item.order_min = undefined;
                        item.order_max = undefined;
                      }
                      return (
                        <ProductCartTVV
                          changeDetected={functionParams}
                          removeProductInPack={removeProductInPack}
                          checkCartRegisterDetailId={checkIsIdExist}
                          packQuantity={productSelectedQuantity || 0}
                          checkPack={checkIsPackEnoughCallBack}
                          handleGetPair={getZmaTsCap}
                          key={index + item.ma_mau}
                          item={item}
                          checked={checked}
                          index={index}
                          handleCheckProduct={handleCheckProduct}
                          handleMinMaxProduct={handleMinMaxProduct}
                          showModal={showModal}
                        />
                      );
                    })}
                  </Row>
                )
              ) : (
                <Table
                  rowKey={(record, index) => record.ma_mau + index}
                  className="customTable2 mt-2 ml-5"
                  size="small"
                  scroll={{ x: 'max-content' }}
                  columns={[
                    {
                      title: (
                        <Row
                          style={{
                            height: '48px',
                            alignItems: 'center',
                            background: '#f1f9ff',
                          }}
                        >
                          <Col
                            style={{
                              position: 'sticky',
                              left: '0',
                              zIndex: '1',
                              background: '#f1f9ff',
                              width: '420px',
                              height: '48px',
                              boxShadow: '3px 0px 3px 0px rgba(0, 0, 0, 0.05)',
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}
                          >
                            <Col
                              style={{
                                width: '30px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                            ></Col>
                            <Col
                              style={{
                                width: '40px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                            >
                              Hình ảnh
                            </Col>
                            <Col
                              style={{
                                width: '150px',
                                paddingLeft: '4px',
                                display: 'flex',
                              }}
                            >
                              Mã mẫu
                              <SortingOutLine
                                id={'ma_mau'}
                                onClick={(event) => handleSortColumn(event)}
                              />
                            </Col>
                            <Col
                              style={{
                                width: '150px',
                                paddingLeft: '4px',
                                display: 'flex',
                              }}
                            >
                              Tên
                              <SortingOutLine
                                id={'ten_mau'}
                                onClick={(event) => handleSortColumn(event)}
                              />
                            </Col>
                          </Col>

                          <Col
                            style={{
                              width: '150px',
                              paddingLeft: '4px',
                              display: 'flex',
                              textAlign: 'right',
                              justifyContent: 'flex-end',
                            }}
                          >
                            Giá vốn
                            <SortingOutLine
                              id={'cost_price'}
                              onClick={(event) => handleSortColumn(event)}
                            />
                          </Col>
                          <Col
                            style={{
                              width: '120px',
                              paddingLeft: '4px',
                              display: 'flex',
                              textAlign: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            Bộ bắt buộc
                          </Col>
                          <Col
                            style={{
                              width: '120px',
                              paddingLeft: '4px',
                              textAlign: 'center',
                            }}
                          >
                            Aging bắt buộc
                          </Col>
                          <Col
                            style={{
                              width: '100px',
                              paddingLeft: '4px',
                              display: 'flex',
                            }}
                          >
                            Màu sắc
                            <SortingOutLine
                              id={'color'}
                              onClick={(event) => handleSortColumn(event)}
                            />
                          </Col>
                          <Col
                            style={{
                              width: '150px',
                              paddingLeft: '4px',
                              display: 'flex',
                            }}
                          >
                            Doanh số 6 tháng
                            <SortingOutLine
                              id={'doanh_so_6_thang_mon'}
                              onClick={(event) => handleSortColumn(event)}
                            />
                          </Col>
                          <Col
                            style={{
                              width: '150px',
                              paddingLeft: '4px',
                              display: 'flex',
                            }}
                          >
                            Tồn hiện tại
                            <SortingOutLine
                              id={'ton_kho_hien_tai_mon'}
                              onClick={(event) => handleSortColumn(event)}
                            />
                          </Col>
                          <Col
                            style={{
                              width: '170px',
                              paddingLeft: '4px',
                              display: 'flex',
                            }}
                          >
                            Giá vốn bình quân
                            <SortingOutLine
                              id={'cost_price'}
                              onClick={(event) => handleSortColumn(event)}
                            />
                          </Col>
                          <Col
                            style={{
                              width: '170px',
                              paddingLeft: '4px',
                              display: 'flex',
                            }}
                          >
                            Giá bán
                            <SortingOutLine
                              id={'price'}
                              onClick={(event) => handleSortColumn(event)}
                            />
                          </Col>
                          <Col
                            style={{
                              width: '170px',
                              paddingLeft: '4px',
                              display: 'flex',
                            }}
                          >
                            Dòng hàng Xman
                            <SortingOutLine
                              id={'line_xman_text'}
                              onClick={(event) => handleSortColumn(event)}
                            />
                          </Col>
                          <Col
                            style={{
                              width: '170px',
                              paddingLeft: '4px',
                              display: 'flex',
                            }}
                          >
                            Ngành hàng
                            <SortingOutLine
                              id={'nganh_hang'}
                              onClick={(event) => handleSortColumn(event)}
                            />
                          </Col>
                          <Col
                            style={{
                              width: '170px',
                              paddingLeft: '4px',
                              display: 'flex',
                            }}
                          >
                            Dòng hàng
                            <SortingOutLine
                              id={'line_sap_text'}
                              onClick={(event) => handleSortColumn(event)}
                            />
                          </Col>
                          <Col
                            style={{
                              width: '170px',
                              paddingLeft: '4px',
                              display: 'flex',
                            }}
                          >
                            Chủng loại
                            <SortingOutLine
                              id={'chung_loai'}
                              onClick={(event) => handleSortColumn(event)}
                            />
                          </Col>
                          <Col
                            style={{
                              width: '170px',
                              paddingLeft: '4px',
                              display: 'flex',
                            }}
                          >
                            Cặp
                            <SortingOutLine
                              id={'zma_ts_cap_text'}
                              onClick={(event) => handleSortColumn(event)}
                            />
                          </Col>
                          <Col
                            style={{
                              width: '170px',
                              paddingLeft: '4px',
                              display: 'flex',
                            }}
                          >
                            Bộ
                            <SortingOutLine
                              id={'zma_bo_text'}
                              onClick={(event) => handleSortColumn(event)}
                            />
                          </Col>
                          <Col
                            style={{
                              width: '170px',
                              paddingLeft: '4px',
                              display: 'flex',
                            }}
                          >
                            Bộ sưu tập
                            <SortingOutLine
                              id={'bst_text'}
                              onClick={(event) => handleSortColumn(event)}
                            />
                          </Col>
                          <Col
                            style={{
                              width: '170px',
                              paddingLeft: '4px',
                              display: 'flex',
                            }}
                          >
                            Nhóm đặc biệt
                            <SortingOutLine
                              id={'nhom_dac_biet'}
                              onClick={(event) => handleSortColumn(event)}
                            />
                          </Col>
                          <Col
                            style={{
                              width: '170px',
                              paddingLeft: '4px',
                              display: 'flex',
                            }}
                          >
                            Giới tính
                            <SortingOutLine
                              id={'gioitinh'}
                              onClick={(event) => handleSortColumn(event)}
                            />
                          </Col>
                          <Col
                            style={{
                              width: '170px',
                              paddingLeft: '4px',
                              display: 'flex',
                            }}
                          >
                            Material type
                            <SortingOutLine
                              id={'material_type'}
                              onClick={(event) => handleSortColumn(event)}
                            />
                          </Col>
                          <Col
                            style={{
                              width: '170px',
                              paddingLeft: '4px',
                              display: 'flex',
                            }}
                          >
                            Tuổi vàng
                            <SortingOutLine
                              id={'purity_of_gold'}
                              onClick={(event) => handleSortColumn(event)}
                            />
                          </Col>
                          <Col
                            style={{
                              width: '170px',
                              paddingLeft: '4px',
                              display: 'flex',
                            }}
                          >
                            Loại đá
                            <SortingOutLine
                              id={'loai_da'}
                              onClick={(event) => handleSortColumn(event)}
                            />
                          </Col>
                          <Col
                            style={{
                              width: '170px',
                              paddingLeft: '4px',
                              display: 'flex',
                            }}
                          >
                            Nhóm đá
                            <SortingOutLine
                              id={'nhom_da'}
                              onClick={(event) => handleSortColumn(event)}
                            />
                          </Col>
                          <Col
                            style={{
                              width: '170px',
                              paddingLeft: '4px',
                              display: 'flex',
                            }}
                          >
                            Size ổ hột
                            <SortingOutLine
                              id={'ohot_kc_text'}
                              onClick={(event) => handleSortColumn(event)}
                            />
                          </Col>

                          <Col
                            style={{
                              width: '170px',
                              paddingLeft: '4px',
                              display: 'flex',
                            }}
                          >
                            Đánh giá toàn quốc
                            <SortingOutLine
                              id={'kldg_3tc'}
                              onClick={(event) => handleSortColumn(event)}
                            />
                          </Col>
                          <Col
                            style={{
                              width: '170px',
                              paddingLeft: '4px',
                              display: 'flex',
                            }}
                          >
                            Đánh giá khu vực
                            <SortingOutLine
                              id={'dghh_kv'}
                              onClick={(event) => handleSortColumn(event)}
                            />
                          </Col>
                          <Col
                            style={{
                              width: '200px',
                              paddingLeft: '4px',
                              display: 'flex',
                            }}
                          >
                            Tổng số lượng tồn hiện tại
                            <SortingOutLine
                              id={'tongsl_ton'}
                              onClick={(event) => handleSortColumn(event)}
                            />
                          </Col>
                          <Col
                            style={{
                              width: '250px',
                              paddingLeft: '4px',
                              display: 'flex',
                            }}
                          >
                            Trung bình doanh thu bán/tháng
                            <SortingOutLine
                              id={'doanhthu_tb_1th'}
                              onClick={(event) => handleSortColumn(event)}
                            />
                          </Col>
                          <Col
                            style={{
                              width: '170px',
                              paddingLeft: '4px',
                              display: 'flex',
                            }}
                          >
                            Aging danh mục
                            <SortingOutLine
                              id={'aging'}
                              onClick={(event) => handleSortColumn(event)}
                            />
                          </Col>
                          <Col
                            style={{
                              width: '170px',
                              paddingLeft: '4px',
                              display: 'flex',
                            }}
                          >
                            Aging cửa hàng
                            <SortingOutLine
                              id={'aging_cua_hang'}
                              onClick={(event) => handleSortColumn(event)}
                            />
                          </Col>
                          <Col
                            style={{
                              width: '184px',
                              height: '48px',
                              alignContent: 'center',
                              textAlign: 'center',
                              position: 'sticky',
                              right: '0',
                              zIndex: '1',
                              background: '#f1f9ff',
                              boxShadow: '-3px 0 3px -0px rgba(0, 0, 0, 0.05)',
                            }}
                          >
                            Đăng ký
                          </Col>
                        </Row>
                      ),
                      render: (_: any, item: any, index: number) => {
                        const checked = productListSelected.some(
                          (product: any) => product.ma_mau === item.ma_mau
                        );
                        const selectedItem = productListSelected.find(
                          (selectedProduct: any) =>
                            selectedProduct.ma_mau === item.ma_mau
                        );
                        if (selectedItem) {
                          item.order_min = selectedItem.order_min;
                          item.order_max = selectedItem.order_max;
                        } else {
                          item.order_min = undefined;
                          item.order_max = undefined;
                        }
                        return (
                          <ProductCartTVV
                            isList={true}
                            changeDetected={functionParams}
                            removeProductInPack={removeProductInPack}
                            checkCartRegisterDetailId={checkIsIdExist}
                            packQuantity={productSelectedQuantity || 0}
                            checkPack={checkIsPackEnoughCallBack}
                            handleGetPair={getZmaTsCap}
                            key={index + item.ma_mau}
                            item={item}
                            checked={checked}
                            index={index}
                            handleCheckProduct={handleCheckProduct}
                            handleMinMaxProduct={handleMinMaxProduct}
                            showModal={showModal}
                          />
                        );
                      },
                    },
                  ]}
                  dataSource={cartData}
                  pagination={false}
                  // onRow={(record: any) => {
                  //   return {
                  //     onClick: () =>
                  //       showModal({ product: record, ChangeValueMin, ChangeValueMax }),
                  //   };
                  // }}
                  // loading={getAllocationLoading}
                  // loading={true}
                />
                // <ProductCartTableTVV
                //   page={page}
                //   page_size={page_size}
                //   productListSelected={productListSelected}
                //   isBoCap={isBoCap}
                //   cart={cartData}
                //   setCartData={setCartData}
                //   handleCheckProduct={handleCheckProduct}
                //   handleMinMaxProduct={handleMinMaxProduct}
                //   showModal={showModal}
                //   removeProductInPack={removeProductInPack}
                //   checkCartRegisterDetailId={checkIsIdExist}
                //   packQuantity={productSelectedQuantity || 0}
                //   checkPack={checkIsPackEnoughCallBack}
                //   handleGetPair={getZmaTsCap}
                // />
              )}

              <Row style={{ marginTop: '20px' }}>
                <Pagination
                  className="flex items-center ml-auto mr-2"
                  current={page}
                  pageSize={page_size}
                  total={total}
                  showSizeChanger={true}
                  pageSizeOptions={['12', '24', '54']}
                  onChange={(page: number, page_size: number) => {
                    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                    history.push('/order-product-list/create', {
                      cart: cart,
                      lstSelected: productListSelected,
                      page: page,
                      page_size: page_size,
                    });
                  }}
                />
              </Row>
            </Content>
          </Layout>
        </Layout>

        <Modal
          title={
            <span className="custom-modal-header">Thông tin sản phẩm</span>
          }
          visible={isModalVisible}
          width={'75%'}
          closeIcon={<CloseOutlined onClick={handleCancel} />}
          style={{ marginTop: '-75px' }}
          footer={null}
        >
          <Divider
            style={{
              borderTop: '1px solid rgba(0, 0, 0, 0.2)',
              marginTop: '8px',
              marginBottom: '0px',
            }}
          />

          <ProductCartInfo
            ref={modalRef}
            data={modalData?.product}
            setMin={modalData?.ChangeValueMin}
            setMax={modalData?.ChangeValueMax}
          />

          <div
            className="flex justify-end"
            style={
              {
                // backgroundColor: '#EFF3F8',
                // padding: '16px 36px',
                // margin: '-20px -24px',
              }
            }
          >
            <Button customClass="end" onClick={handleCancel}>
              Đóng lại
            </Button>
          </div>
        </Modal>

        <Modal
          open={isStatusModalOpen}
          onCancel={() => setIsStatusModalOpen(false)}
          footer={null}
          width={'30%'}
        >
          <Result
            status="warning"
            title={
              <p>
                Đơn hàng đã được gửi đi <br />{' '}
                <span>Bạn không thể đặt hàng</span>
              </p>
            }
            extra={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                onClick={() => setIsStatusModalOpen(false)}
              >
                <Button>Đóng</Button>
              </div>
            }
          />
        </Modal>
        <PopupConfirmBase
          isVisible={isModalOpen}
          title={'Thông báo'}
          description={'Giỏ hàng đã hết hạn'}
          onlyOK={true}
          onOk={() => {
            setIsModalOpen(false);
          }}
        ></PopupConfirmBase>
        <PopupOrderConfirm
          isVisible={isModalConfirmOpen}
          onCancel={() => {
            setIsModalConfirmOpen(false);
          }}
          onStay={() => {
            createOrder('no_push');
          }}
          onOk={() => {
            createOrder('push');
          }}
        ></PopupOrderConfirm>
      </Spin>
    </MainLayout>
  );
}
